module.exports = function (e, g, h, j, k, m, q, u, v) {
  var w;
  var x;
  var y = {
    _html: {
      panelButtons: function (z, A, B = false) {
        let C =
          '<div class="' +
          (z == "left" ? "right" : "left") +
          ' panelButton" style="' +
          (B ? "border-bottom-right-radius:5px" : "") +
          '" onclick="KE.resizable.hide(this)">\n                <div class="hide"><i class="material-icons hide">keyboard_arrow_' +
          z +
          "</i></div></div>";
        let D = B
          ? "<div></div>"
          : '<div class="' +
            (z == "left" ? "left" : "right") +
            ' panelButton" onclick="GUI.panel.state.lock(this, \'' +
            z +
            '\')">\n               <div class="lock""><i class="material-icons lock">lock' +
            (y.panel[z].locked ? "" : "_open") +
            "</i></div></div>";
        let E = B ? "<div></div>" : "<div class='panelLabel'>" + A + "</div>";
        return (
          '<div class="panelButtonLayout">' +
          (z == "left" ? D + E + C : C + E + D) +
          "</div>"
        );
      },
      arrow: function (z) {
        return (
          '<i class="material-icons" style="transform: translateY(5px) rotate(' +
          {
            up: -45,
            down: 135,
            left: -135,
            right: 45,
          }[z] +
          'deg)">call_made</i>'
        );
      },
      folder: {
        standard: function (z, A = "", B = "", C = false) {
          return (
            '<div id="' +
            z.toLowerCase() +
            'H" class="header" onclick="GUI.update.folder(this);' +
            B +
            '">\n                  <i class="material-icons">keyboard_arrow_' +
            (C ? "right" : "down") +
            "</i><a>" +
            z +
            '</a></div><hr>\n                  <div id="' +
            z.toLowerCase() +
            'B" style="' +
            (C ? "display:none" : "") +
            '">' +
            A +
            "<hr></div>"
          );
        },
        small: function (z, A = "", B = "", C = false, D = false) {
          return (
            '<div id="' +
            z.toLowerCase() +
            'H" class="' +
            (D ? "sub" : "") +
            'subheader" style="cursor: pointer"\n                  onclick="GUI.update.folder(this);' +
            B +
            '"><i class="material-icons">keyboard_arrow_' +
            (C ? "right" : "down") +
            "</i><a>" +
            z +
            '</a></div>\n                  <div id="' +
            z.toLowerCase() +
            'B" style="' +
            (C ? "display:none" : "") +
            '">' +
            A +
            "</div>"
          );
        },
      },
      line: {
        standard: function (z, A = "", B = 0) {
          return (
            '<div class="inlineItem"><div class="section ' +
            (["subsection", "subsubsection"][B - 1] || "") +
            '">' +
            z +
            "</div>\n                  <div>" +
            A +
            "</div></div>"
          );
        },
        wide: function (z, A = "") {
          return "<div>" + A + "</div>";
        },
      },
      input: {
        resizable: {
          button: function (z, A = "", B) {
            return '<div class="button" onclick="' + A + '">' + B + "</div>";
          },
          key: function (z = "", A = "", B = [], C = false) {
            return (
              '<div class="inlineLabel ' +
              (C ? "" : "disabled") +
              '" href="#" ' +
              (C ? 'onclick="' + A + '"' : "") +
              ">" +
              [z, ...B].join(" or ") +
              "</div>"
            );
          },
          text: function (z = "", A = "", B = "") {
            return (
              '<input class="inlineInput" type="text" placeholder="' +
              B +
              '" value="' +
              z +
              '" oninput="' +
              A +
              '" onchange="GUI.update.field(this)">'
            );
          },
          number: function (z = 0, A = "", B = "", C = "", D = "", E = "") {
            return (
              '<input class="inlineInput" type="number" placeholder="' +
              B +
              '" value="' +
              z +
              '" min="' +
              C +
              '" max="' +
              D +
              '" step="' +
              E +
              '"\n                     onmousedown="GUI.update.number.mousedown(this)" onchange="GUI.update.field(this);GUI.update.number.change(this);' +
              A +
              '">'
            );
          },
          color: function (z = "#ffffff", A = "") {
            return (
              '<input class="color" style="background-color:' +
              z +
              ";color:" +
              h.stringifyColor(h.parseColor(z) < 7829367 ? 16777215 : 0) +
              '"\n                     type="text" spellcheck="false" value="' +
              z +
              '" onchange="GUI.update.field(this);GUI.update.color.change(this);' +
              A +
              '"\n                     onmousedown="GUI.update.color.mousedown(this)">'
            );
          },
          switch: function (z = false, A = "") {
            return (
              '<label class="switch" style="margin-top: 10px"><input type="checkbox"\n                     onclick="' +
              A +
              '" ' +
              (z ? "checked" : "") +
              '><span class="slider"></span></label>'
            );
          },
          slider: function (z = 0, A = "", B = 0, C = 1, D = 0.1) {
            return (
              '<div style="zoom:0.7;margin-top:12px;">\n                     <input type="number" class="sliderVal" min="' +
              B +
              '" max="' +
              C +
              '" value="' +
              z +
              '"\n                     onchange="GUI.update.field(this);GUI.update.slider.val(this);' +
              A +
              '"><div class="slidecontainer"><input type="range"\n                     min="' +
              B +
              '" max="' +
              C +
              '" step="' +
              D +
              '" value="' +
              z +
              '" class="sliderM" oninput="GUI.update.slider.M(this);' +
              A +
              '">\n                     </div></div>'
            );
          },
          select: function (z = 0, A = "", B) {
            return (
              '<select onchange="' +
              A +
              '">' +
              B.map(
                (C) =>
                  '<option value="' +
                  C.value +
                  '"\n                     ' +
                  (z == C.value ? "selected" : "") +
                  ">" +
                  C.name +
                  "</option>",
              ) +
              "</select>"
            );
          },
        },
        fixed: {
          vector3: function (z, A = "", B = [0, 0, 0], C = "", D = "", E = "") {
            return (
              '<div class="section">' +
              z +
              '</div><div class="vector3">\n                     ' +
              e.xyzKeys
                .map(
                  (F, G) =>
                    '<input type="number" placeholder="' +
                    F +
                    '" min="' +
                    C +
                    '" max="' +
                    D +
                    '" step="' +
                    E +
                    '"\n                     onmousedown="GUI.update.number.mousedown(this)" onchange="GUI.update.field(this);GUI.update.number.change(this);' +
                    A +
                    '"\n                     value="' +
                    B[G] +
                    '">',
                )
                .join("\n") +
              "</div>"
            );
          },
        },
      },
      toolbar: {
        root: function (z, A) {
          return (
            '<div class="toolbarItem" onmouseover="GUI.update.toolbar(this, true)" onmouseout="GUI.update.toolbar(this)">\n                  ' +
            z +
            '<div class="toolbarDropDown">' +
            A +
            "</div></div>"
          );
        },
        menu: function (z, A) {
          return (
            '<div class="toolbarDropDownItem" onmouseover="GUI.update.toolbar(this, true)" onmouseout="GUI.update.toolbar(this)">\n                  ' +
            z +
            '<div class="toolbarSubDropDown" style="top: this.offsetTop">' +
            A +
            "</div></div>"
          );
        },
        option: function (z, A = "") {
          return (
            '<div class="toolbarDropDownItem" onclick=";' +
            A +
            '">' +
            z +
            "</div>"
          );
        },
        textarea: function (z, A = "") {
          return (
            '<div class="toolbarDropDownItem textarea" onclick=";' +
            A +
            '"><textarea class="qs_textarea" rows="5"></textarea></div>'
          );
        },
      },
    },
    update: {
      folder: function (z) {
        let A = document.getElementById(
          z.id.substring(0, z.id.length - 1) + "B",
        );
        let B = A.style.display == "none";
        z.children[0].innerHTML = "keyboard_arrow_" + (B ? "down" : "right");
        A.style.display = B ? null : "none";
      },
      field: function (z) {
        z.blur();
      },
      key: {
        choice: {},
        keydown: function (z) {
          let A = y.update.key.choice;
          if (A.elem) {
            if ((z = window.event || z).key.toUpperCase().length == 1) {
              A.callback(z.key.toUpperCase(), true);
            } else {
              A.callback(A.prev);
            }
            A.elem = null;
          }
        },
        mousedown: function (z) {
          let A = y.update.key.choice;
          if (A.elem) {
            z = window.event || z;
            A.callback(A.prev);
            A.elem = null;
          }
        },
      },
      number: {
        mousedown: function (z) {
          y.update.number.elem = z;
        },
        mousemove: function (z) {
          let A = y.update.number.elem;
          z = window.event || z;
          if (A) {
            A.value =
              parseFloat(A.value) - z.movementY * (parseFloat(A.step) || 1);
            if (A.min && A.value < A.min) {
              A.value = parseFloat(A.min);
            }
            if (A.max && A.value > A.max) {
              A.value = parseFloat(A.max);
            }
            A.onchange();
          }
        },
        mouseup: function () {
          delete y.update.number.elem;
        },
        change: function (z) {
          if (z.value == "") {
            z.value = 0;
          }
        },
      },
      color: {
        init: function () {
          let z = document.createElement("div");
          z.style.display = "none";
          document.body.appendChild(z);
          y.update.color.pickr = Pickr.create({
            el: z,
            theme: "nano",
            comparison: false,
            lockOpacity: true,
            autoReposition: false,
            closeOnScroll: true,
            components: {
              preview: false,
              hue: true,
            },
          });
          y.update.color.pickr
            .on("show", function (A, B) {
              let C = y.update.color.elem.getBoundingClientRect();
              let D = C.y;
              let E = C.x + C.width + 4;
              D =
                window.innerHeight - D < B._root.app.offsetHeight
                  ? D - B._root.app.offsetHeight + C.height
                  : D;
              E =
                window.innerWidth - E < B._root.app.offsetWidth
                  ? E - B._root.app.offsetWidth - C.width - 8
                  : E;
              B._root.app.style.top = D + "px";
              B._root.app.style.left = E + "px";
              B.setColor(y.update.color.elem.value);
            })
            .on("change", function (A) {
              let B = y.update.color.elem;
              if (B) {
                B.value = A.toHEXA().toString();
                B.onchange();
              }
            })
            .on("hide", function () {
              delete y.update.color.elem;
            });
        },
        change: function (z) {
          let A = z.style.backgroundColor;
          let B = A.substr(4, A.length - 5).split(", ");
          z.value = h.isHexColor(z.value) ? z.value : h.rgbToHex(...B);
          z.style.backgroundColor = z.value;
          z.style.color = h.stringifyColor(
            h.parseColor(z.value) < 7829367 ? 16777215 : 0,
          );
          y.update.color.pickr.setColor(z.value);
        },
        mousedown: function (z) {
          e = window.event || e;
          if (e.which === 1) {
            y.update.color.show = true;
            y.update.color.elem = z;
            y.update.color.pickr.show();
          }
        },
      },
      slider: {
        val: function (z) {
          z.parentElement.children[1].children[0].value = Math.max(
            Math.min(z.value, z.max),
            z.min,
          );
          z.value = z.parentElement.children[1].children[0].value;
        },
        M: function (z) {
          z.parentElement.parentElement.children[0].value = z.value;
        },
      },
      toolbar: function (z, A) {
        if (A) {
          z.children[0].style.display = "block";
          if (
            z.children[0].className == "toolbarSubDropDown" &&
            !z.children[0].style.top
          ) {
            setTimeout(function () {
              z.children[0].style.top = z.offsetTop + "px";
            }, 0);
          }
        } else {
          z.children[0].style.display = null;
        }
      },
    },
    action: function (z, A) {
      let B = y;
      z.forEach((C) => (B = B[C]));
      switch (B.type) {
        case "toolbar":
          if (e.quickGUI._hidden) {
            let I = A;
            z.slice(z.indexOf("blueprint") + 2).forEach(
              () => (I = I.parentElement),
            );
            y.update.toolbar(I);
          } else if (B.pos != "textarea") {
            e.quickGUI.hide();
          }
          if (B.onClick) {
            B.onClick(A);
          }
          break;
        case "folder":
          let C =
            document.getElementById(A.id.substring(0, A.id.length - 1) + "B")
              .style.display == "none";
          let D = [...z];
          D[D.indexOf("blueprint")] = "folderStore";
          let E = y;
          D.forEach((J) => (E = E[J] ? E[J] : (E[J] = {})));
          E.closed = C;
          break;
        case "vector3":
          let F = [...A.parentElement.children].map((J) => parseFloat(J.value));
          B.object[B.key] = F;
          if (B.onChange) {
            B.onChange(A, F);
          }
          break;
        case "key":
          let G = y.update.key.choice;
          G.prev = A.innerHTML;
          A.innerHTML = "Press Any Key";
          G.callback = function (J, K) {
            A.innerHTML = [J, ...B.args[0]].join(" or ");
            if (K) {
              B.object[B.key] = J;
              if (B.onChange) {
                B.onChange(A, J);
              }
            }
          };
          G.elem = A;
          break;
        default:
          let H =
            A.type == "checkbox"
              ? A.checked
              : ["text", "select-one"].includes(A.type)
                ? A.value
                : parseFloat(A.value);
          if (typeof B.object[B.key] == "function") {
            B.object[B.key]();
          } else {
            B.object[B.key] = H;
          }
          if (B.onChange) {
            B.onChange(A, H);
          }
      }
    },
    _build: function (z) {
      let A = y;
      z.forEach((B) => (A = A[B]));
      return Object.keys(A)
        .map((B) => {
          let C = A[B];
          let D =
            "GUI.action(" +
            JSON.stringify([...z, B]).replace(/\"/g, "'") +
            ", this)";
          switch (C.type) {
            case "panel_buttons":
              return y._html.panelButtons(C.direction, C.label, C.blank);
            case "rule":
              return "<hr>";
            case "div":
              return (
                "<div id=" +
                C.id +
                " " +
                (C.show ? null : 'style="display: none"') +
                ">" +
                y._build([...z, B, "children"]) +
                "</div>"
              );
            case "toolbar":
              if (["option", "textarea"].includes(C.pos)) {
                return y._html.toolbar[C.pos](C.name, D);
              } else {
                return y._html.toolbar[C.pos](
                  C.name,
                  y._build([...z, B, "children"]),
                );
              }
            case "folder":
              let E = [...z, B];
              E[E.indexOf("blueprint")] = "folderStore";
              let F = y;
              E.forEach((G) => (F = F[G] ? F[G] : (F[G] = {})));
              if (e.settings.preserveFolderState && F.closed != null) {
                C.closed = F.closed;
              } else {
                F.closed = !!C.closed;
              }
              return y._html.folder[C.size](
                C.name,
                y._build([...z, B, "children"]),
                D,
                C.closed,
                C.sub,
              );
            case "vector3":
              return y._html.input.fixed.vector3(
                C.name,
                D,
                C.object[C.key],
                C.min,
              );
            default:
              return y._html.line[C.line || "standard"](
                C.name,
                y._html.input.resizable[C.type](
                  C.object[C.key],
                  D,
                  ...(C.args ? C.args : []),
                ),
                C.sub,
              );
          }
        })
        .join("\n");
    },
    _toolbar: {
      elem: document.getElementById("_toolbar"),
      show: function () {
        let z = [];
        let A = [];
        let B = [];
        let C = [];
        for (let D in k.prefabs) {
          if (
            (!k.prefabs[D].localOnly || !j.isProd) &&
            !k.prefabs[D].custom &&
            !k.prefabs[D].noExport &&
            k.prefabs[D].name != ""
          ) {
            (k.prefabs[D].ai
              ? C
              : k.prefabs[D].tool || k.prefabs[D].tool2
                ? A
                : k.prefabs[D].gen
                  ? z
                  : B
            ).push({
              name: h.formatConstName(k.prefabs[D].name),
              type: "toolbar",
              pos: "option",
              onClick: function () {
                e.createObjects[D]();
              },
            });
          }
        }
        this.blueprint = {
          file: {
            name: "File",
            type: "toolbar",
            pos: "root",
            children: {
              import: {
                name: "Import...",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  if (window.event.shiftKey) {
                    e.loadFile("importMap");
                  } else {
                    e.importMap();
                  }
                },
              },
              export: {
                name: "Export...",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  if (window.event.shiftKey) {
                    e.copyToClipboard(e.getMapExport());
                  }
                  e.exportMap();
                },
              },
              exportGLTF: {
                name: "Export GLTF",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.exportScene();
                },
              },
              publish: {
                name: "Publish...",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.publishMap();
                },
              },
              rule0: {
                type: "rule",
              },
              saveAs: {
                name: "Save As",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.save();
                },
              },
              rule1: {
                type: "rule",
              },
              new: {
                name: "New",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  if (confirm("Are you sure you want to reset the map?")) {
                    e.clearMap();
                  }
                },
              },
              copy: {
                name: "Copy",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  h.copyToClipboard(e.getMapExport());
                },
              },
            },
          },
          edit: {
            name: "Edit",
            type: "toolbar",
            pos: "root",
            children: {
              undo: {
                name: "Undo",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.executeHistory("undo");
                },
              },
              redo: {
                name: "Redo",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.executeHistory("redo");
                },
              },
              rule0: {
                type: "rule",
              },
              delete: {
                name: "Delete",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  if (e.objectSelected(true)) {
                    e.removeGroup();
                  } else {
                    e.removeObject();
                  }
                },
              },
              duplicate: {
                name: "Duplicate",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  if (e.objectSelected(true)) {
                    e.duplicateGroup();
                  } else {
                    e.duplicateObject();
                  }
                },
              },
              rule1: {
                type: "rule",
              },
              settings: {
                name: "Settings...",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  showWindow(3);
                },
              },
            },
          },
          object: {
            name: "Object",
            type: "toolbar",
            pos: "root",
            children: {
              basic: {
                name: "Basic",
                type: "toolbar",
                pos: "menu",
                children: {
                  ...B,
                },
              },
              models: {
                name: "Models",
                type: "toolbar",
                pos: "menu",
                children: {
                  ...z,
                },
              },
              tools: {
                name: "Tools",
                type: "toolbar",
                pos: "menu",
                children: {
                  ...A,
                },
              },
              ai: {
                name: "AI",
                type: "toolbar",
                pos: "menu",
                children: {
                  ...C,
                },
              },
              rule0: {
                type: "rule",
              },
              placeHolder: {
                name: "Placeholder",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.createPlaceholder();
                },
              },
              group: {
                name: "Group",
                type: "toolbar",
                pos: "menu",
                children: {
                  create: {
                    name: "Create",
                    type: "toolbar",
                    pos: "option",
                    onClick: function () {
                      e.advancedOptions.create();
                    },
                  },
                  stop: {
                    name: "Stop",
                    type: "toolbar",
                    pos: "option",
                    onClick: function () {
                      e.advancedOptions.stop();
                    },
                  },
                  stopAll: {
                    name: "Stop All",
                    type: "toolbar",
                    pos: "option",
                    onClick: function () {
                      e.advancedOptions.stopAll();
                    },
                  },
                  rule0: {
                    type: "rule",
                  },
                  copy: {
                    name: "Copy",
                    type: "toolbar",
                    pos: "option",
                    onClick: function () {
                      e.advancedOptions.copy();
                    },
                  },
                  cut: {
                    name: "Cut",
                    type: "toolbar",
                    pos: "option",
                    onClick: function () {
                      e.advancedOptions.cut();
                    },
                  },
                  paste: {
                    name: "Paste",
                    type: "toolbar",
                    pos: "option",
                    onClick: function () {
                      e.advancedOptions.paste();
                    },
                  },
                  rule1: {
                    type: "rule",
                  },
                  prefab: {
                    name: "Prefab",
                    type: "toolbar",
                    pos: "menu",
                    children: {
                      import: {
                        name: "Import",
                        type: "toolbar",
                        pos: "menu",
                        children: {
                          json: {
                            name: "JSON",
                            type: "toolbar",
                            pos: "option",
                            onClick: function () {
                              e.advancedOptions.json();
                            },
                          },
                          file: {
                            name: "File",
                            type: "toolbar",
                            pos: "option",
                            onClick: function () {
                              e.advancedOptions.file();
                            },
                          },
                        },
                      },
                      export: {
                        name: "Export",
                        type: "toolbar",
                        pos: "option",
                        onClick: function () {
                          e.advancedOptions.exportObj();
                        },
                      },
                    },
                  },
                  rule2: {
                    type: "rule",
                  },
                  edit: {
                    name: "Edit",
                    type: "toolbar",
                    pos: "option",
                    onClick: function () {
                      y.panel.right.grouping.show();
                    },
                  },
                },
              },
              rule1: {
                type: "rule",
              },
              custom: {
                name: "Custom...",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.createObjects[44]();
                },
              },
            },
          },
          component: {
            name: "Component",
            type: "toolbar",
            pos: "root",
            children: {
              environment: {
                name: "Environment",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  y.panel.right.environment.show();
                },
              },
              terrain: {
                name: "Terrain",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  y.panel.right.terrain.show();
                },
              },
              zone: {
                name: "Zone",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  y.panel.right.zone.show();
                },
              },
              rule: {
                type: "rule",
              },
              tools: {
                name: "Tools",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  y.panel.right.tools.show();
                },
              },
            },
          },
          map: {
            name: "Map",
            type: "toolbar",
            pos: "root",
            children: {
              testMap: {
                name: "Test Map",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.testMap();
                },
              },
              hostMap: {
                name: "Host Map",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.testMap(true);
                },
              },
              rule0: {
                type: "rule",
              },
              quickStart: {
                name: "Quick Start",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.quickStart();
                },
              },
              rule1: {
                type: "rule",
              },
              customize: {
                name: "Customize",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  y.panel.right.customize.show();
                },
              },
            },
          },
          help: {
            name: "Help",
            type: "toolbar",
            pos: "root",
            children: {
              keybinds: {
                name: "Controls...",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  showWindow(1);
                },
              },
            },
          },
        };
        this.elem.innerHTML = y._build([...this.objKeys, "blueprint"]);
      },
    },
    panel: {
      state: {
        lock: function (z, A) {
          let B = z.children[0].children[0];
          let C = B.innerHTML.includes("open");
          B.innerHTML = "lock" + (C ? "" : "_open");
          y.panel[A].locked = C;
        },
        setActive: function (z) {
          y.panel[z[1]].elem.id = z.join("_");
        },
        isActive: function (z) {
          return y.panel[z[1]].elem.id == z.join("_");
        },
        refresh: function (z) {
          if (!document.getElementById(z)) {
            return;
          }
          let A = y;
          z.split("_").forEach((B) => (A = A[B]));
          if (A.show) {
            A.show();
          }
        },
        refreshAll: function () {
          return h
            .getObjKeys(y.panel, [
              "state",
              "blueprint",
              "objKeys",
              "folderStore",
              "show",
              "elem",
              "restore",
            ])
            .forEach((z) => {
              y.panel.state.refresh("panel_" + z.replace(/\|/g, "_"));
            });
        },
      },
      left: {
        elem: document.getElementsByClassName("panel")[0].children[1],
        restore: document.getElementsByClassName("restore")[0],
        essential: {
          show: function () {
            e.resizable.restore(y.panel.left.restore);
            if (!y.panel.left.locked || y.panel.state.isActive(this.objKeys)) {
              let B = [];
              let C = [];
              for (var z = 0; z < j.gameConfig.length; z++) {
                if (!(w = j.gameConfig[z]).cost) {
                  if (e.gameConfig[w.varN] == null) {
                    e.gameConfig[w.varN] = w.def;
                  }
                  if (w.varN == "aID") {
                    (w.cat ? C : B).push({
                      name: w.name + " ID",
                      object: e.gameConfig,
                      key: w.varN,
                      type: "text",
                      args: ["ID"],
                      sub: 1,
                    });
                  } else if (w.bool) {
                    (w.cat ? C : B).push({
                      name: w.name,
                      object: e.gameConfig,
                      key: w.varN,
                      type: "switch",
                      sub: 1,
                    });
                  } else if (w.input) {
                    (w.cat ? C : B).push({
                      name: w.name,
                      object: e.gameConfig,
                      key: w.varN,
                      type: "text",
                      sub: 1,
                    });
                  } else if (w.select) {
                    (w.cat ? C : B).push({
                      name: w.name,
                      object: e.gameConfig,
                      key: w.varN,
                      type: "select",
                      args: [
                        w.options.map((H, I) => ({
                          name: H,
                          value: I,
                        })),
                      ],
                      sub: 1,
                    });
                  } else {
                    (w.cat ? C : B).push({
                      name: w.name,
                      object: e.gameConfig,
                      key: w.varN,
                      type: "slider",
                      args: [w.min, w.maxF || w.maxP || w.max, w.step],
                      sub: 1,
                    });
                  }
                }
              }
              let D = [];
              for (z = 0; z < u.length; z++) {
                if (!(w = u[z]).cost && !w.preventCustomGames) {
                  if (e.serverConfig.modes[z] == null) {
                    e.serverConfig.modes[z] = !z;
                  }
                  D.push({
                    name: w.name,
                    object: e.serverConfig.modes,
                    key: z,
                    type: "switch",
                    sub: 1,
                  });
                }
              }
              let E = [];
              for (z = 0; z < q.length; z++) {
                if (!(w = q[z]).cost) {
                  if (e.serverConfig.classes[z] == null) {
                    e.serverConfig.classes[z] = true;
                  }
                  E.push({
                    name: w.name,
                    object: e.serverConfig.classes,
                    key: z,
                    type: "switch",
                    sub: 1,
                  });
                }
              }
              let F = [];
              for (z = 0; z < j.serverConfig.length; z++) {
                if (!(w = j.serverConfig[z]).cost && !w.hideE) {
                  if (e.serverConfig.settings[w.varN] == null) {
                    e.serverConfig.settings[w.varN] = w.def;
                  }
                  if (w.bool) {
                    F.push({
                      name: w.name,
                      object: e.serverConfig.settings,
                      key: w.varN,
                      type: "switch",
                      sub: 1,
                    });
                  } else if (w.input) {
                    F.push({
                      name: w.name,
                      object: e.serverConfig.settings,
                      key: w.varN,
                      type: "text",
                      sub: 1,
                    });
                  } else if (w.select) {
                    F.push({
                      name: w.name,
                      object: e.serverConfig.settings,
                      key: w.varN,
                      type: "select",
                      args: [
                        w.options.map((H, I) => ({
                          name: H,
                          value: I,
                        })),
                      ],
                      sub: 1,
                    });
                  } else {
                    F.push({
                      name: w.name,
                      object: e.serverConfig.settings,
                      key: w.varN,
                      type: "slider",
                      args: [w.min, w.maxF || w.maxP || w.max, w.step],
                      sub: 1,
                    });
                  }
                }
              }
              let G = [];
              for (var A = 0; A < m.length; A++) {
                w = m[A];
                G["w" + A] = {
                  name: w.name,
                  type: "folder",
                  size: "small",
                  children: [],
                  closed: true,
                };
                if (e.serverConfig.weps[A] == null) {
                  e.serverConfig.weps[A] = {};
                }
                for (z = 0; z < j.weaponConfig.length; z++) {
                  x = j.weaponConfig[z];
                  if (m[A][x.varN] != null) {
                    if (e.serverConfig.weps[A][x.varN] == null) {
                      e.serverConfig.weps[A][x.varN] = m[A][x.varN];
                    }
                    if (x.bool) {
                      G["w" + A].children.push({
                        name: x.name,
                        object: e.serverConfig.weps[A],
                        key: x.varN,
                        type: "switch",
                        sub: 1,
                      });
                    } else {
                      G["w" + A].children.push({
                        name: x.name,
                        object: e.serverConfig.weps[A],
                        key: x.varN,
                        type: "slider",
                        args: [x.min, x.max, x.step],
                        sub: 1,
                      });
                    }
                  }
                }
              }
              this.blueprint = {
                panelButtons: {
                  type: "panel_buttons",
                  direction: "left",
                  label: "Essential",
                },
                mapName: {
                  name: "Name",
                  object: e.mapConfig,
                  key: "name",
                  type: "text",
                  args: ["Name"],
                },
                welMsg: {
                  name: "Welcome Msg",
                  object: e.mapConfig,
                  key: "welMsg",
                  type: "text",
                  args: ["Welcome"],
                },
                modURL: {
                  name: "Mod URL",
                  object: e.mapConfig,
                  key: "modURL",
                  type: "text",
                  args: ["Mod URL"],
                },
                selectMod: {
                  line: "wide",
                  object: e.advancedOptions,
                  key: "selectMod",
                  type: "button",
                  args: ["Select Mod"],
                },
                deathHeight: {
                  name: "Death Height",
                  object: e.mapConfig,
                  key: "dthY",
                  type: "slider",
                  args: [-1000, 3000, 1],
                  onChange: function (H, I) {
                    e.mapConfig.dthY = I;
                    e.updateDeathBarrier();
                  },
                },
                rule: {
                  type: "rule",
                },
                gameConfig: {
                  name: "Game",
                  type: "folder",
                  size: "standard",
                  children: {
                    camera: {
                      name: "Camera",
                      type: "folder",
                      size: "small",
                      children: {
                        ...B,
                      },
                      closed: true,
                    },
                    player: {
                      name: "Player",
                      type: "folder",
                      size: "small",
                      children: {
                        ...C,
                      },
                      closed: true,
                    },
                    modes: {
                      name: "Modes",
                      type: "folder",
                      size: "small",
                      children: {
                        ...D,
                      },
                      closed: true,
                    },
                    classes: {
                      name: "Classes",
                      type: "folder",
                      size: "small",
                      children: {
                        ...E,
                      },
                      closed: true,
                    },
                    settings: {
                      name: "Settings",
                      type: "folder",
                      size: "small",
                      children: {
                        ...F,
                      },
                      closed: true,
                    },
                  },
                },
                weaponConfig: {
                  name: "Weapon Config",
                  type: "folder",
                  size: "standard",
                  children: {
                    ...G,
                  },
                  closed: true,
                },
              };
              y.panel.state.setActive(this.objKeys);
              y.panel.left.elem.innerHTML = y._build([
                ...this.objKeys,
                "blueprint",
              ]);
            }
          },
        },
      },
      right: {
        elem: document.getElementsByClassName("panel")[1].children[1],
        restore: document.getElementsByClassName("restore")[1],
        blank: {
          show: function () {
            if (
              !y.panel.right.locked ||
              !!y.panel.state.isActive(this.objKeys)
            ) {
              this.blueprint = {
                panelButtons: {
                  type: "panel_buttons",
                  direction: "right",
                  blank: true,
                },
              };
              y.panel.state.setActive(this.objKeys);
              y.panel.right.elem.innerHTML = y._build([
                ...this.objKeys,
                "blueprint",
              ]);
            }
          },
        },
        object: {
          show: function () {
            if (y.panel.right.locked && !y.panel.state.isActive(this.objKeys)) {
              return;
            }
            this.blueprint = {
              panelButtons: {
                type: "panel_buttons",
                direction: "right",
                label: "Object",
              },
            };
            y.panel.right.blank.show();
            let z = e.transformControl.object;
            if (!z) {
              return;
            }
            let A = z.userData.owner;
            this.blueprint.panelButtons.label = A.name;
            for (var B of e.configVal) {
              e.objConfig[B] = A[B];
            }
            let C = {};
            let D = e.objConfig;
            for (let E of e.stringifiedColors) {
              Object.defineProperty(C, E, {
                get: () => h.stringifyColor(D[E]),
                set: (F) => (D[E] = h.parseColor(F)),
              });
            }
            if (A.prefab.ai) {
              this.blueprint.aiName = {
                name: "AI Name",
                object: e.objConfig,
                key: "aiName",
                type: "text",
                args: ["BOT"],
                onChange: function (F, G) {
                  A.aiName = G;
                },
              };
            }
            if (!A.prefab.tool || A.prefab.bounce) {
              this.blueprint.visible = {
                name: "Visible",
                object: e.objConfig,
                key: "visible",
                type: "switch",
                onChange: function (F, G) {
                  A.visible = G;
                },
              };
            }
            if (
              !A.prefab.tool &&
              !A.prefab.forceCollision &&
              !A.prefab.noCollision
            ) {
              this.blueprint.collidable = {
                name: "Collidable",
                object: e.objConfig,
                key: "collidable",
                type: "switch",
                onChange: function (F, G) {
                  e.objCount[e.cntCheck(A)]--;
                  A.collidable = G;
                  e.objCount[e.cntCheck(A)]++;
                  e.warningCheck("objects");
                  e.updateObjectCount();
                },
              };
            }
            if (A.prefab.editPen) {
              this.blueprint.penetrable = {
                name: "Penetrable",
                object: e.objConfig,
                key: "penetrable",
                type: "switch",
                onChange: function (F, G) {
                  A.penetrable = G;
                },
              };
            }
            if (A.prefab.canWallJump) {
              this.blueprint.canWallJump = {
                name: "Wall Jumpable",
                object: e.objConfig,
                key: "canWallJump",
                type: "switch",
                onChange: function (F, G) {
                  A.canWallJump = G;
                },
              };
            }
            if (A.prefab.boostable) {
              this.blueprint.boost = {
                name: "Boost",
                object: e.objConfig,
                key: "boost",
                type: "slider",
                args: [-10, 10, 0.1],
                onChange: function (F, G) {
                  A.boost = G;
                },
              };
            }
            if (A.prefab.bounce) {
              this.blueprint.bounce = {
                name: "Bounce",
                object: e.objConfig,
                key: "bounce",
                type: "slider",
                args: [0.1, 3, 0.1],
                onChange: function (F, G) {
                  A.bounce = G;
                },
              };
              this.blueprint.crouch = {
                name: "Crouch Reduces",
                object: e.objConfig,
                key: "crouch",
                type: "switch",
                onChange: function (F, G) {
                  A.crouch = G;
                },
              };
            }
            if (A.prefab.edgeNoise) {
              this.blueprint.edgeNoise = {
                name: "Edge Noise",
                object: e.objConfig,
                key: "edgeNoise",
                type: "slider",
                args: [-5, 5, 0.1],
                onChange: function (F, G) {
                  A.edgeNoise = G;
                },
              };
            }
            if (A.prefab.hasBorder) {
              this.blueprint.border = {
                name: "Border",
                object: e.objConfig,
                key: "border",
                type: "switch",
                onChange: function (F, G) {
                  A.border = G;
                },
              };
            }
            if (A.prefab.hasSpin) {
              this.blueprint.spin = {
                name: "Spin",
                object: e.objConfig,
                key: "spin",
                type: "slider",
                args: [-20, 20, 0],
                onChange: function (F, G) {
                  A.spin = G;
                },
              };
            }
            if (A.prefab.name == "CYLINDER") {
              this.blueprint.openEnded = {
                name: "Open Ended",
                object: e.objConfig,
                key: "openEnded",
                type: "switch",
                onChange: function (F, G) {
                  A.openEnded = G;
                  A.regen();
                },
              };
            }
            if (A.prefab.customDirection) {
              this.blueprint.direction = {
                name: "Direction",
                object: e.objConfig,
                key: "direction",
                type: "slider",
                args: [0, 3, 1],
                onChange: function (F, G) {
                  A.direction = G;
                },
              };
            }
            if (A.prefab.optionalDirection) {
              this.blueprint.forceDir = {
                name: "Force Direction",
                object: e.objConfig,
                key: "forceDir",
                type: "switch",
                onChange: function (F, G) {
                  A.forceDir = G;
                },
              };
            }
            if (A.prefab.teamable) {
              this.blueprint.teamable = {
                name: "Team",
                object: e.objConfig,
                key: "team",
                type: "select",
                args: [
                  A.prefab.noDefault
                    ? [
                        {
                          name: "Team 1",
                          value: 0,
                        },
                        {
                          name: "Team 2",
                          value: 1,
                        },
                      ]
                    : [
                        {
                          name: "Default",
                          value: 0,
                        },
                        {
                          name: "Team 1",
                          value: 1,
                        },
                        {
                          name: "Team 2",
                          value: 2,
                        },
                      ],
                ],
                onChange: function (F, G) {
                  A.team = G;
                  if (A.objType == "SPAWN_POINT") {
                    A.regen();
                  }
                },
              };
            }
            if (A.prefab.gen) {
              this.blueprint.mSize = {
                name: "Model Scale",
                object: e.objConfig,
                key: "mSize",
                type: "slider",
                args: [0.1, 100, 0.1],
                onChange: function (F, G) {
                  A.mSize = G;
                  A.regenM();
                },
              };
            }
            if (A.prefab.name == "SHOWCASE") {
              this.blueprint.itemID = {
                name: "Item",
                object: e.objConfig,
                key: "itemID",
                type: "select",
                args: [
                  Object.keys(e.skinList).map((F) => ({
                    name: F,
                    value: e.skinList[F],
                  })),
                ],
                onChange: function (F, G) {
                  A.itemID = G;
                  A.regenM();
                },
              };
            }
            if (A.prefab.objectiveLink) {
              this.blueprint.objectiveId = {
                name: "Objective Id",
                object: e.objConfig,
                key: "objectiveId",
                type: "slider",
                args: [-1, 10, 1],
                onChange: function (F, G) {
                  A.objectiveId = G;
                },
              };
            }
            this.blueprint.rule = {
              type: "rule",
            };
            this.blueprint.transform = {
              name: "Transform",
              type: "folder",
              size: "standard",
              children: {
                position: {
                  name: "Position",
                  object: e.objConfig,
                  key: "pos",
                  type: "vector3",
                  onChange: function (F, G) {
                    A.pos = G;
                  },
                },
                rotation: {
                  name: "Rotation",
                  object: e.objConfig,
                  key: "rot",
                  type: "vector3",
                  onChange: function (F, G) {
                    A.rot = e.degToRad(G);
                  },
                },
              },
            };
            if (A.prefab.scalable) {
              this.blueprint.transform.children.size = {
                name: "Size",
                object: e.objConfig,
                key: "size",
                type: "vector3",
                min: 0,
                onChange: function (F, G) {
                  A.size = G;
                },
              };
            }
            if (!A.prefab.notStyleable) {
              this.blueprint.style = {
                name: "Style",
                type: "folder",
                size: "standard",
                children: {},
              };
              if (A.prefab.texturable || A.prefab.movingTexture) {
                this.blueprint.style.children.texture = {
                  name: "Texture",
                  type: "folder",
                  size: "small",
                  children: {},
                  closed: true,
                };
              }
              if (A.prefab.ai) {
                this.blueprint.style.children.assetID = {
                  name: "Asset ID",
                  object: e.objConfig,
                  key: "assetID",
                  type: "text",
                  args: ["ID"],
                  onChange: function (F, G) {
                    A.assetID = G;
                    A.regenM();
                  },
                  sub: 1,
                };
                this.blueprint.style.children.customSelect = {
                  line: "wide",
                  object: e.advancedOptions,
                  key: "selectModel",
                  type: "button",
                  args: ["Select Custom"],
                };
              }
              if (A.prefab.texturable) {
                this.blueprint.style.children.texture.children.type = {
                  name: "Type",
                  object: e.objConfig,
                  key: "texture",
                  type: "select",
                  args: [
                    Object.keys(e.textureList).map((F) => ({
                      name: F,
                      value: e.textureList[F],
                    })),
                  ],
                  onChange: function (F, G) {
                    A.assetTexture = 0;
                    A.texture = G;
                    e.updateObjConfigGUI();
                  },
                  sub: 1,
                };
                if (A.prefab.assetTextures) {
                  this.blueprint.style.children.texture.children.custom = {
                    name: "Asset ID",
                    object: e.objConfig,
                    key: "assetTexture",
                    type: "number",
                    args: ["Texture Asset ID", 0],
                    onChange: function (F, G) {
                      A.assetTexture = G;
                    },
                    sub: 1,
                  };
                  this.blueprint.style.children.texture.children.customSelect =
                    {
                      line: "wide",
                      object: e.advancedOptions,
                      key: "selectTexture",
                      type: "button",
                      args: ["Select Custom"],
                    };
                }
                if (A.prefab.canStretch) {
                  this.blueprint.style.children.texture.children.stretch = {
                    name: "Stretch",
                    object: e.objConfig,
                    key: "texStretch",
                    type: "switch",
                    onChange: function (F, G) {
                      A.texStretch = G;
                      A.regen();
                    },
                    sub: 1,
                  };
                }
                this.blueprint.style.children.texture.children.offset = {
                  name: "Offset",
                  type: "folder",
                  size: "small",
                  children: {
                    x: {
                      name: "X",
                      object: e.objConfig,
                      key: "texOffX",
                      type: "slider",
                      args: [0, 1, 0.1],
                      onChange: function (F, G) {
                        A.texOffX = G;
                      },
                      sub: 2,
                    },
                    y: {
                      name: "Y",
                      object: e.objConfig,
                      key: "texOffY",
                      type: "slider",
                      args: [0, 1, 0.1],
                      onChange: function (F, G) {
                        A.texOffY = G;
                      },
                      sub: 2,
                    },
                  },
                  sub: 1,
                };
              }
              if (A.prefab.movingTexture) {
                this.blueprint.style.children.texture.children.movement = {
                  name: "Movement",
                  type: "folder",
                  size: "small",
                  children: {
                    speed: {
                      name: "Speed",
                      object: e.objConfig,
                      key: "movingSpeed",
                      type: "slider",
                      args: [-20, 20, 0.1],
                      onChange: function (F, G) {
                        A.movingSpeed = G;
                      },
                      sub: 2,
                    },
                    axis: {
                      name: "Axis",
                      object: e.objConfig,
                      key: "movingAxis",
                      type: "select",
                      args: [
                        [
                          {
                            name: "X",
                            value: 0,
                          },
                          {
                            name: "Y",
                            value: 1,
                          },
                        ],
                      ],
                      onChange: function (F, G) {
                        A.movingAxis = G;
                      },
                      sub: 2,
                    },
                  },
                  sub: 1,
                };
              }
              if (A.prefab.editColor) {
                this.blueprint.style.children.color = {
                  name: "Color",
                  object: C,
                  key: "color",
                  type: "color",
                  onChange: function (F, G) {
                    A.color = G;
                  },
                };
              }
              if (A.prefab.editEmissive) {
                this.blueprint.style.children.emissive = {
                  name: "Emissive",
                  object: C,
                  key: "emissive",
                  type: "color",
                  onChange: function (F, G) {
                    A.emissive = G;
                  },
                };
              }
              if (A.prefab.editOpac) {
                this.blueprint.style.children.opacity = {
                  name: "Opacity",
                  object: e.objConfig,
                  key: "opacity",
                  type: "slider",
                  args: [0, 1, 0.1],
                  onChange: function (F, G) {
                    A.opacity = G;
                  },
                };
              }
              if (A.prefab.custom) {
                this.blueprint.style.children.texSmooth = {
                  name: "Texture Smoothing",
                  object: e.objConfig,
                  key: "texSmooth",
                  type: "switch",
                  onChange: function (F, G) {
                    A.texSmooth = G;
                  },
                };
              }
              if (!A.prefab.complex && !A.prefab.tool) {
                this.blueprint.style.children.shading = {
                  name: "Shading",
                  object: e.objConfig,
                  key: "ambient",
                  type: "switch",
                  onChange: function (F, G) {
                    A.ambient = G;
                  },
                };
              }
              if (A.prefab.editFog) {
                this.blueprint.style.children.fog = {
                  name: "Fog",
                  object: e.objConfig,
                  key: "fog",
                  type: "switch",
                  onChange: function (F, G) {
                    A.fog = G;
                  },
                };
              }
              if (A.objType == "LIGHT_CONE") {
                this.blueprint.style.children.lightCone = {
                  name: "Full Cone",
                  object: e.objConfig,
                  key: "fullcone",
                  type: "switch",
                  onChange: function (F, G) {
                    A.fullcone = G;
                    A.regen(true);
                  },
                };
              }
            }
            if (A.prefab.editFaces) {
              this.blueprint.renderFaces = {
                name: "Render Faces",
                type: "folder",
                size: "standard",
                children: {
                  ...e.faces.map((F, G) => ({
                    name: F,
                    object: e.objConfig.faces,
                    key: G,
                    type: "switch",
                    onChange: function () {
                      A.faces = e.objConfig.faces;
                      A.regen();
                    },
                  })),
                },
              };
            }
            if (A.prefab.light) {
              this.blueprint.lighting = {
                name: "Lighting",
                type: "folder",
                size: "standard",
                children: {
                  intensity: {
                    name: "Intensity",
                    object: e.objConfig,
                    key: "intensity",
                    type: "slider",
                    args: [0, 2, 0.1],
                    onChange: function (F, G) {
                      A.intensity = G;
                    },
                  },
                  distance: {
                    name: "Distance",
                    object: e.objConfig,
                    key: "distance",
                    type: "slider",
                    args: [0, 1000, 0.1],
                    onChange: function (F, G) {
                      A.distance = G;
                    },
                  },
                  decay: {
                    name: "Decay",
                    object: e.objConfig,
                    key: "decay",
                    type: "slider",
                    args: [0, 2, 0.1],
                    onChange: function (F, G) {
                      A.decay = G;
                    },
                  },
                },
              };
            }
            if (!A.prefab.notTechnical) {
              let F = {};
              if (A.objType == "DEPOSIT_BOX") {
                F = {
                  withdraw: {
                    name: "Withdraw Amount",
                    object: e.objConfig,
                    key: "withdraw",
                    type: "slider",
                    args: [0, 100000, 1],
                    onChange: function (H, I) {
                      A.withdraw = I;
                    },
                  },
                  deposit: {
                    name: "Deposit Amount",
                    object: e.objConfig,
                    key: "deposit",
                    type: "slider",
                    args: [0, 100000, 1],
                    onChange: function (H, I) {
                      A.deposit = I;
                    },
                  },
                };
              }
              if (A.prefab.customScore) {
                F.customScore = {
                  name: A.prefab.interact ? "Amount" : "Score",
                  object: e.objConfig,
                  key: "score",
                  type: "slider",
                  args: [A.prefab.interact || A.prefab.ai ? 0 : 1, 10000, 1],
                  onChange: function (H, I) {
                    A.score = I;
                  },
                };
              }
              if (
                A.objType == "CHECK_POINT" ||
                A.objType == "TRIGGER" ||
                A.prefab.ai
              ) {
                F.customScore = {
                  name: "Single Use",
                  object: e.objConfig,
                  key: "single",
                  type: "switch",
                  onChange: function (H, I) {
                    A.single = I;
                  },
                };
              }
              if (A.prefab.interact || A.prefab.interact2) {
                if (A.prefab.interact) {
                  F.method = {
                    name: "Method",
                    object: e.objConfig,
                    key: "method",
                    type: "select",
                    args: [
                      [
                        {
                          name: "Cost Score",
                          value: 0,
                        },
                        {
                          name: "Require Score",
                          value: 1,
                        },
                        {
                          name: "Require Kills",
                          value: 2,
                        },
                      ],
                    ],
                    onChange: function (H, I) {
                      A.method = I;
                    },
                  };
                  if (A.prefab.canUndo) {
                    F.closeable = {
                      name: "Closeable",
                      object: e.objConfig,
                      key: "closeable",
                      type: "switch",
                      onChange: function (H, I) {
                        A.closeable = I;
                      },
                    };
                    F.startsClosed = {
                      name: "Starts Hidden",
                      object: e.objConfig,
                      key: "startClosed",
                      type: "switch",
                      onChange: function (H, I) {
                        A.startClosed = I;
                      },
                    };
                  }
                }
                F.hidden = {
                  name: "No Popup",
                  object: e.objConfig,
                  key: "hidden",
                  type: "switch",
                  onChange: function (H, I) {
                    A.hidden = I;
                  },
                };
              }
              if (A.prefab.hasHealth) {
                F.canDestroy = {
                  name: "Destructible",
                  object: e.objConfig,
                  key: "canDestroy",
                  type: "switch",
                  onChange: function (H, I) {
                    A.canDestroy = I;
                  },
                };
                if (A.prefab.name != "GATE") {
                  F.startDestroyed = {
                    name: "Start Destroyed",
                    object: e.objConfig,
                    key: "startDestroyed",
                    type: "switch",
                    onChange: function (H, I) {
                      A.startDestroyed = I;
                    },
                  };
                }
                if (A.prefab.name == "TRIGGER") {
                  F.selfDestruct = {
                    name: "Destroy On Use",
                    object: e.objConfig,
                    key: "selfDestruct",
                    type: "switch",
                    onChange: function (H, I) {
                      A.selfDestruct = I;
                    },
                  };
                }
                F.health = {
                  name: "Health",
                  object: e.objConfig,
                  key: "health",
                  type: "slider",
                  args: [0, 20000, 10],
                  onChange: function (H, I) {
                    A.health = I;
                  },
                };
              }
              if (A.prefab.hasHealth) {
                F.respawn = {
                  name: "Respawn",
                  type: "folder",
                  size: "small",
                  children: {
                    timer: {
                      name: "Timer (s)",
                      object: e.objConfig,
                      key: "respawnT",
                      type: "slider",
                      args: [0, 300, 0.1],
                      onChange: function (H, I) {
                        A.respawnT = I;
                      },
                      sub: 1,
                    },
                    random: {
                      name: "Random",
                      object: e.objConfig,
                      key: "respawnR",
                      type: "switch",
                      onChange: function (H, I) {
                        A.respawnR = I;
                      },
                      sub: 1,
                    },
                  },
                };
              }
              if (A.objType == "WEAPON_PICKUP") {
                F.weapon = {
                  name: "Weapon",
                  type: "folder",
                  size: "small",
                  children: {
                    type: {
                      name: "Type",
                      object: e.objConfig,
                      key: "weaponId",
                      type: "select",
                      args: [
                        m
                          .map((H, I) =>
                            H.src
                              ? {
                                  name: H.name,
                                  value: I,
                                }
                              : null,
                          )
                          .filter((H) => H),
                      ],
                      onChange: function (H, I) {
                        A.weaponId = I;
                        A.regen();
                      },
                      sub: 1,
                    },
                    replace: {
                      name: "Replaceable",
                      object: e.objConfig,
                      key: "weaponReplace",
                      type: "switch",
                      onChange: function (H, I) {
                        A.weaponReplace = I;
                      },
                      sub: 1,
                    },
                    random: {
                      name: "Random",
                      object: e.objConfig,
                      key: "randWep",
                      type: "switch",
                      onChange: function (H, I) {
                        A.randWep = I;
                      },
                      sub: 1,
                    },
                  },
                };
              }
              if (A.objType == "TRIGGER" || A.prefab.ai) {
                if (A.prefab.ai) {
                  F.canTrigger = {
                    name: "Can Trigger",
                    object: e.objConfig,
                    key: "canTrigger",
                    type: "switch",
                    onChange: function (H, I) {
                      A.canTrigger = I;
                    },
                  };
                }
                F.event = {
                  name: "Event",
                  object: e.objConfig,
                  key: "event",
                  type: "select",
                  args: [
                    v.events
                      .map((H, I) => ({
                        name: H,
                        value: I,
                      }))
                      .filter(
                        (H) =>
                          (!!A.prefab.ai && !!H.name.includes("onAI")) ||
                          (A.objType == "TRIGGER" && !H.name.includes("onAI")),
                      ),
                  ],
                  onChange: function (H, I) {
                    A.event = I;
                  },
                };
                F.constantEvent = {
                  name: "Event Value",
                  object: e.objConfig,
                  key: "constantEvent",
                  type: "slider",
                  args: [0, 10000, 1],
                  onChange: function (H, I) {
                    A.constantEvent = I;
                  },
                };
                F.action = {
                  name: "Action",
                  object: e.objConfig,
                  key: "action",
                  type: "select",
                  args: [
                    v.actions.map((H, I) => ({
                      name: H.name,
                      value: I,
                    })),
                  ],
                  onChange: function (H, I) {
                    var J =
                      (v.actions[A.action] &&
                        (v.actions[A.action].type == "Text" ||
                          v.actions[A.action].custom)) ||
                      (v.actions[I] &&
                        (v.actions[I].type == "Text" || v.actions[I].custom));
                    A.action = I;
                    if (J) {
                      y.panel.state.refresh("panel_right_object");
                    }
                  },
                };
                if (v.actions[A.action] && v.actions[A.action].type == "Text") {
                  F.constantTxt = {
                    name: "Value",
                    object: e.objConfig,
                    key: "constantTxt",
                    type: "text",
                    args: ["Text"],
                    onChange: function (H, I) {
                      A.constantTxt = I;
                    },
                  };
                } else {
                  F.constant = {
                    name: "Value",
                    object: e.objConfig,
                    key: "constant",
                    type: "slider",
                    args: [-10000, 10000, 1],
                    onChange: function (H, I) {
                      A.constant = I;
                    },
                  };
                }
                F.chance = {
                  name: "Action Chance (%)",
                  object: e.objConfig,
                  key: "chance",
                  type: "slider",
                  args: [0, 100, 1],
                  onChange: function (H, I) {
                    A.chance = I;
                  },
                };
              }
              let G = {};
              if (A.objType != "WEAPON_PICKUP" && A.prefab.canInterface) {
                G.id = {
                  name: "ID",
                  object: e.objConfig,
                  key: "interfaceId",
                  type: "slider",
                  args: [0, j.interfaceIDMax, 1],
                  onChange: function (H, I) {
                    var J = I != A.interfaceId;
                    if (A.interfaceId) {
                      e.warningCheck("interface", A, -1);
                    }
                    A.interfaceId = I;
                    if (A.interfaceId) {
                      e.warningCheck("interface", A, 1);
                    }
                    if (J) {
                      e.checkConnections();
                    }
                  },
                  sub: 1,
                };
              }
              if (A.prefab.canTargetInterface) {
                G.target = {
                  name: "Target",
                  object: e.objConfig,
                  key: "interfaceIdT",
                  type: "slider",
                  args: [0, 1000, 1],
                  onChange: function (H, I) {
                    var J = I != A.interfaceIdT;
                    A.interfaceIdT = I;
                    if (J) {
                      e.checkConnections();
                    }
                  },
                  sub: 1,
                };
              }
              if (Object.keys(G).length) {
                F.interface = {
                  name: "Interface",
                  type: "folder",
                  size: "small",
                  children: G,
                };
              }
              if (A.prefab.name == "TELEPORTER") {
                F.node = {
                  name: "Node",
                  object: e.objConfig,
                  key: "node",
                  type: "select",
                  args: [
                    [
                      {
                        name: "Sending",
                        value: 0,
                      },
                      {
                        name: "Receiving",
                        value: 1,
                      },
                      {
                        name: "Both",
                        value: 2,
                      },
                    ],
                  ],
                  onChange: function (H, I) {
                    A.node = I;
                  },
                };
                F.channel = {
                  name: "Channel",
                  object: e.objConfig,
                  key: "channel",
                  type: "slider",
                  args: [0, 100, 1],
                  onChange: function (H, I) {
                    A.channel = I;
                  },
                };
                F.momentum = {
                  name: "Stop Momentum",
                  object: e.objConfig,
                  key: "momentum",
                  type: "switch",
                  onChange: function (H, I) {
                    A.momentum = I;
                  },
                };
              }
              if (A.prefab.canBeDynamic) {
                F.dynamic = {
                  name: "Dynamic",
                  type: "folder",
                  size: "small",
                  children: {
                    dynamic: {
                      name: "Enabled",
                      object: e.objConfig,
                      key: "dynamic",
                      type: "switch",
                      onChange: function (H, I) {
                        A.dynamic = I;
                      },
                      sub: 1,
                    },
                    gravity: {
                      name: "Gravity",
                      object: e.objConfig,
                      key: "gravity",
                      type: "slider",
                      args: [0, 5, 0.1],
                      onChange: function (H, I) {
                        A.gravity = I;
                      },
                      sub: 1,
                    },
                  },
                };
              }
              if (A.prefab.ai) {
                F.behavior = {
                  name: "Behavior",
                  type: "folder",
                  size: "small",
                  children: {
                    behaviorType: {
                      name: "Behavior Type",
                      object: e.objConfig,
                      key: "behaviorType",
                      type: "slider",
                      args: [0, 20, 1],
                      onChange: function (H, I) {
                        A.behaviorType = I;
                      },
                      sub: 1,
                    },
                    speed: {
                      name: "Speed",
                      object: e.objConfig,
                      key: "speed",
                      type: "slider",
                      args: [0, 5, 0.1],
                      onChange: function (H, I) {
                        A.speed = I;
                      },
                      sub: 1,
                    },
                    turnSpd: {
                      name: "Turn Speed",
                      object: e.objConfig,
                      key: "turnSpd",
                      type: "slider",
                      args: [0, 30, 1],
                      onChange: function (H, I) {
                        A.turnSpd = I;
                      },
                      sub: 1,
                    },
                    gravity: {
                      name: "Gravity",
                      object: e.objConfig,
                      key: "gravity",
                      type: "slider",
                      args: [0, 1, 0.1],
                      onChange: function (H, I) {
                        A.gravity = I;
                      },
                      sub: 1,
                    },
                    frate: {
                      name: "Firerate",
                      object: e.objConfig,
                      key: "frate",
                      type: "slider",
                      args: [200, 10000, 50],
                      onChange: function (H, I) {
                        A.frate = I;
                      },
                      sub: 1,
                    },
                    visDis: {
                      name: "Vision Distance",
                      object: e.objConfig,
                      key: "visDis",
                      type: "slider",
                      args: [10, 1000, 10],
                      onChange: function (H, I) {
                        A.visDis = I;
                      },
                      sub: 1,
                    },
                    xrayVis: {
                      name: "Xray Vision",
                      object: e.objConfig,
                      key: "xrayVis",
                      type: "switch",
                      onChange: function (H, I) {
                        A.xrayVis = I;
                      },
                      sub: 1,
                    },
                    canShoot: {
                      name: "Can Shoot",
                      object: e.objConfig,
                      key: "canShoot",
                      type: "switch",
                      onChange: function (H, I) {
                        A.canShoot = I;
                      },
                      sub: 1,
                    },
                    canHit: {
                      name: "Can Hit",
                      object: e.objConfig,
                      key: "canHit",
                      type: "switch",
                      onChange: function (H, I) {
                        A.canHit = I;
                      },
                      sub: 1,
                    },
                    projType: {
                      name: "Projectile Type",
                      object: e.objConfig,
                      key: "projType",
                      type: "slider",
                      args: [0, 5, 1],
                      onChange: function (H, I) {
                        A.projType = I;
                      },
                      sub: 1,
                    },
                    rewardType: {
                      name: "Reward Type",
                      object: e.objConfig,
                      key: "rewardType",
                      type: "text",
                      args: ["id,id,id"],
                      onChange: function (H, I) {
                        A.rewardType = I;
                      },
                      sub: 1,
                    },
                  },
                };
              }
              if (Object.keys(F).length) {
                this.blueprint.technical = {
                  name: "Technical",
                  type: "folder",
                  size: "standard",
                  children: F,
                };
              }
            }
            if (A.objType == "BILLBOARD") {
              this.blueprint.billboard = {
                name: "Billboard",
                type: "folder",
                size: "standard",
                children: {
                  poster: {
                    name: "Poster",
                    object: e.objConfig,
                    key: "poster",
                    type: "slider",
                    args: [1, j.billboardCnt, 1],
                    onChange: function (H, I) {
                      A.poster = I;
                      A.regen(true);
                    },
                  },
                  showAd: {
                    name: "Show AD",
                    object: e.objConfig,
                    key: "showAd",
                    type: "switch",
                    onChange: function (H, I) {
                      A.showAd = I;
                    },
                  },
                },
              };
            }
            if (A.objType == "PARTICLES") {
              this.blueprint.particles = {
                name: "Particles",
                type: "folder",
                size: "standard",
                children: {
                  texture: {
                    name: "Texture",
                    object: e.objConfig,
                    key: "part",
                    type: "select",
                    args: [
                      Object.keys(e.particleList).map((H) => ({
                        name: H,
                        value: e.particleList[H],
                      })),
                    ],
                    onChange: function (H, I) {
                      A.part = I;
                    },
                  },
                  blending: {
                    name: "Blending",
                    object: e.objConfig,
                    key: "partB",
                    type: "select",
                    args: [
                      Object.keys(e.blendingList).map((H) => ({
                        name: H,
                        value: e.blendingList[H],
                      })),
                    ],
                    onChange: function (H, I) {
                      A.partB = I;
                    },
                  },
                  count: {
                    name: "Count",
                    object: e.objConfig,
                    key: "partC",
                    type: "slider",
                    args: [0, 300, 1],
                    onChange: function (H, I) {
                      A.partC = I;
                    },
                  },
                  size: {
                    name: "Size",
                    object: e.objConfig,
                    key: "partS",
                    type: "slider",
                    args: [0, 30, 0.1],
                    onChange: function (H, I) {
                      A.partS = I;
                    },
                  },
                  scale: {
                    name: "Scale",
                    object: e.objConfig,
                    key: "partSC",
                    type: "slider",
                    args: [-10, 10, 0.1],
                    onChange: function (H, I) {
                      A.partSC = I;
                    },
                  },
                  movement: {
                    name: "Movement",
                    type: "folder",
                    size: "small",
                    children: {
                      speed: {
                        name: "Speed",
                        object: e.objConfig,
                        key: "partSP",
                        type: "slider",
                        args: [-10, 10, 0.1],
                        onChange: function (H, I) {
                          A.partSP = I;
                        },
                        sub: 1,
                      },
                      deceleration: {
                        name: "Deceleration",
                        object: e.objConfig,
                        key: "partD",
                        type: "slider",
                        args: [-1, 1, 0.1],
                        onChange: function (H, I) {
                          A.partD = I;
                        },
                        sub: 1,
                      },
                      gravity: {
                        name: "Gravity",
                        object: e.objConfig,
                        key: "partG",
                        type: "slider",
                        args: [-10, 10, 0.1],
                        onChange: function (H, I) {
                          A.partG = I;
                        },
                        sub: 1,
                      },
                    },
                  },
                },
              };
            }
            if (A.prefab.hasText) {
              this.blueprint.text = {
                name: "Text",
                type: "folder",
                size: "standard",
                children: {
                  content: {
                    name: "Content",
                    object: e.objConfig,
                    key: "text",
                    type: "text",
                    args: ["Content"],
                    onChange: function (H, I) {
                      A.text = I;
                      A.regen(true);
                    },
                  },
                  align: {
                    name: "Align",
                    object: e.objConfig,
                    key: "tAlign",
                    type: "select",
                    args: [
                      [
                        {
                          name: "Left",
                          value: 0,
                        },
                        {
                          name: "Center",
                          value: 1,
                        },
                        {
                          name: "Right",
                          value: 2,
                        },
                      ],
                    ],
                    onChange: function (H, I) {
                      A.tAlign = I;
                      A.regen(true);
                    },
                  },
                  font: {
                    name: "Font",
                    type: "folder",
                    size: "small",
                    children: {
                      size: {
                        name: "Size",
                        object: e.objConfig,
                        key: "fsize",
                        type: "slider",
                        args: [j.signFontMin, j.signFontMax, 1],
                        onChange: function (H, I) {
                          A.fsize = I;
                          A.regen(true);
                        },
                        sub: 1,
                      },
                      color: {
                        name: "Color",
                        object: C,
                        key: "fcolor",
                        type: "color",
                        onChange: function (H, I) {
                          A.fcolor = I;
                          A.regen(true);
                        },
                        sub: 1,
                      },
                    },
                  },
                  background: {
                    name: "Background",
                    type: "folder",
                    size: "small",
                    children: {
                      color: {
                        name: "Color",
                        object: C,
                        key: "bcolor",
                        type: "color",
                        onChange: function (H, I) {
                          A.bcolor = I;
                          A.regen(true);
                        },
                        sub: 1,
                      },
                      visible: {
                        name: "Visible",
                        object: e.objConfig,
                        key: "backVisible",
                        type: "switch",
                        onChange: function (H, I) {
                          A.backVisible = I;
                          A.regen(true);
                        },
                        sub: 1,
                      },
                    },
                  },
                },
              };
            }
            if (A.objType == "SPAWN_POINT") {
              this.blueprint.spawnpoint = {
                name: "Spawn Point",
                type: "folder",
                size: "standard",
                children: {
                  cmpSpwn: {
                    name: "Starting Area",
                    object: e.objConfig,
                    key: "cmpSpwn",
                    type: "switch",
                    onChange: function (H, I) {
                      A.cmpSpwn = I;
                      A.regen();
                    },
                  },
                },
              };
            }
            if (A.objType == "LIQUID") {
              this.blueprint.liquid = {
                name: "Wave",
                type: "folder",
                size: "standard",
                children: {
                  wave: {
                    name: "Liquid",
                    type: "folder",
                    size: "small",
                    children: {
                      speed: {
                        name: "Speed",
                        object: e.objConfig,
                        key: "wSpeed",
                        type: "slider",
                        args: [0, 25, 0.1],
                        onChange: function (H, I) {
                          A.wSpeed = I;
                        },
                        sub: 1,
                      },
                      height: {
                        name: "Height",
                        object: e.objConfig,
                        key: "wHeight",
                        type: "slider",
                        args: [0, 5, 0.1],
                        onChange: function (H, I) {
                          A.wHeight = I;
                        },
                        sub: 1,
                      },
                    },
                  },
                  depth: {
                    name: "Depth",
                    type: "folder",
                    size: "small",
                    children: {
                      x: {
                        name: "X",
                        object: e.objConfig,
                        key: "tilesX",
                        type: "slider",
                        args: [2, 100, 1],
                        onChange: function (H, I) {
                          A.tilesX = I;
                          A.regen();
                        },
                        sub: 1,
                      },
                      z: {
                        name: "Z",
                        object: e.objConfig,
                        key: "tilesZ",
                        type: "slider",
                        args: [2, 100, 1],
                        onChange: function (H, I) {
                          A.tilesZ = I;
                          A.regen();
                        },
                        sub: 1,
                      },
                    },
                  },
                },
              };
            }
            if (
              A.objType == "SOUND_EMITTER" ||
              (A.prefab.hasSound && A.action == 14)
            ) {
              this.blueprint.sound = {
                name: "Sound",
                type: "folder",
                size: "standard",
                children: {
                  type: {
                    name: "Type",
                    object: e.objConfig,
                    key: "snd",
                    type: "select",
                    args: [
                      Object.keys(e.soundsList).map((H) => ({
                        name: H,
                        value: e.soundsList[H],
                      })),
                    ],
                    onChange: function (H, I) {
                      A.snd = I;
                    },
                  },
                  custom: {
                    name: "Asset ID",
                    object: e.objConfig,
                    key: "assetSound",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (H, I) {
                      A.assetSound = I;
                    },
                  },
                  customSelect: {
                    line: "wide",
                    object: e.advancedOptions,
                    key: "selectAudio",
                    type: "button",
                    args: ["Select Custom"],
                  },
                  volume: {
                    name: "Volume",
                    object: e.objConfig,
                    key: "vol",
                    type: "slider",
                    args: [j.emitterVolMin, j.emitterVolMax, 0.01],
                    onChange: function (H, I) {
                      A.vol = I;
                    },
                  },
                  rate: {
                    name: "Rate",
                    object: e.objConfig,
                    key: "rate",
                    type: "slider",
                    args: [j.emitterRateMin, j.emitterRateMax, 0.1],
                    onChange: function (H, I) {
                      A.rate = I;
                    },
                  },
                },
              };
              if (A.objType == "SOUND_EMITTER") {
                this.blueprint.sound.children.dist = {
                  name: "Reference Distance",
                  object: e.objConfig,
                  key: "dist",
                  type: "slider",
                  args: [j.emitterDistMin, j.emitterDistMax, 1],
                  onChange: function (H, I) {
                    A.dist = I;
                  },
                };
                this.blueprint.sound.children.roll = {
                  name: "Roll-off",
                  object: e.objConfig,
                  key: "roll",
                  type: "slider",
                  args: [j.emitterRollMin, j.emitterRollMax, 0.01],
                  onChange: function (H, I) {
                    A.roll = I;
                  },
                };
              } else {
                this.blueprint.sound.children.emitfrom = {
                  name: "Emit From",
                  object: e.objConfig,
                  key: "emitfrom",
                  type: "select",
                  args: [
                    [
                      {
                        name: "Trigger",
                        value: 0,
                      },
                      {
                        name: "Player",
                        value: 1,
                      },
                    ],
                  ],
                  onChange: function (H, I) {
                    A.emitfrom = I;
                  },
                };
              }
            }
            if (A.prefab.ai) {
              this.blueprint.sound = {
                name: "Sound",
                type: "folder",
                size: "standard",
                children: {
                  death: {
                    name: "Death Sound ID",
                    object: e.objConfig,
                    key: "deathSound",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (H, I) {
                      A.deathSound = I;
                    },
                  },
                  customDeath: {
                    line: "wide",
                    object: e.advancedOptions,
                    key: "selectDeath",
                    type: "button",
                    args: ["Select Sound"],
                  },
                  idle: {
                    name: "Idle Sound ID",
                    object: e.objConfig,
                    key: "idleSound",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (H, I) {
                      A.idleSound = I;
                    },
                  },
                  customIdle: {
                    line: "wide",
                    object: e.advancedOptions,
                    key: "selectIdle",
                    type: "button",
                    args: ["Select Sound"],
                  },
                  atk: {
                    name: "Attack Sound ID",
                    object: e.objConfig,
                    key: "atkSound",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (H, I) {
                      A.atkSound = I;
                    },
                  },
                  customAtk: {
                    line: "wide",
                    object: e.advancedOptions,
                    key: "selectAttack",
                    type: "button",
                    args: ["Select Sound"],
                  },
                  agro: {
                    name: "Agro Sound ID",
                    object: e.objConfig,
                    key: "agroSound",
                    type: "number",
                    args: ["Sound Asset ID", 0],
                    onChange: function (H, I) {
                      A.agroSound = I;
                    },
                  },
                  customAgro: {
                    line: "wide",
                    object: e.advancedOptions,
                    key: "selectAgro",
                    type: "button",
                    args: ["Select Sound"],
                  },
                },
              };
            }
            y.panel.state.setActive(this.objKeys);
            y.panel.right.elem.innerHTML = y._build([
              ...this.objKeys,
              "blueprint",
            ]);
          },
        },
        environment: {
          show: function () {
            e.resizable.restore(y.panel.right.restore);
            if (y.panel.right.locked && !y.panel.state.isActive(this.objKeys)) {
              return;
            }
            let z = ["ambient", "sky", "light", "fog"];
            let A = {};
            let B = e.mapConfig;
            for (let C of z) {
              Object.defineProperty(A, C, {
                get: () => h.stringifyColor(B[C]),
                set: (D) => (B[C] = h.parseColor(D)),
              });
            }
            this.blueprint = {
              panelButtons: {
                type: "panel_buttons",
                direction: "right",
                label: "Environment",
              },
              enabled: {
                name: "Sky",
                object: e.mapConfig,
                key: "skyDome",
                type: "select",
                args: [
                  ["Solid", "Gradient"].map((D, E) => ({
                    name: D,
                    value: E,
                  })),
                ],
                onChange: function (D, E) {
                  [...D.children].forEach((F) => {
                    document.getElementById("sky_" + F.value).style.display =
                      "none";
                  });
                  document.getElementById("sky_" + E).style.display = null;
                  e.mapConfig.skyDome = !!parseInt(E);
                  e.regenSky();
                },
              },
              sky0: {
                type: "div",
                id: "sky_0",
                show: !e.mapConfig.skyDome,
                children: {
                  color: {
                    name: "Color",
                    object: A,
                    key: "sky",
                    type: "color",
                    onChange: function (D, E) {
                      e.backgroundScene.background = new g.Color(E);
                      e.regenSky();
                    },
                    sub: 1,
                  },
                },
              },
              sky1: {
                type: "div",
                id: "sky_1",
                show: !!e.mapConfig.skyDome,
                children: {
                  color: {
                    name: "Color",
                    type: "folder",
                    size: "small",
                    children: {
                      top: {
                        name: "Top",
                        object: e.mapConfig,
                        key: "skyDomeCol0",
                        type: "color",
                        onChange: function () {
                          e.regenSky();
                        },
                        sub: 2,
                      },
                      middle: {
                        name: "Middle",
                        object: e.mapConfig,
                        key: "skyDomeCol1",
                        type: "color",
                        onChange: function () {
                          e.regenSky();
                        },
                        sub: 2,
                      },
                      bottom: {
                        name: "Bottom",
                        object: e.mapConfig,
                        key: "skyDomeCol2",
                        type: "color",
                        onChange: function () {
                          e.regenSky();
                        },
                        sub: 2,
                      },
                    },
                    sub: 1,
                  },
                  cloudTexture: {
                    name: "Cloud Texture",
                    object: e.mapConfig,
                    key: "skyDomeTex",
                    type: "switch",
                    onChange: function (D, E) {
                      cloud.style.display = E ? null : "none";
                      e.regenSky();
                    },
                    sub: 1,
                  },
                  cloud: {
                    type: "div",
                    id: "cloud",
                    show: e.mapConfig.skyDomeTex,
                    children: {
                      emissive: {
                        name: "Emissive",
                        object: e.mapConfig,
                        key: "skyDomeEmis",
                        type: "color",
                        onChange: function () {
                          e.regenSky();
                        },
                        sub: 2,
                      },
                      speed: {
                        name: "Speed",
                        object: e.mapConfig,
                        key: "skyDomeMovT",
                        type: "slider",
                        args: [-20, 20, 0.1],
                        onChange: function () {
                          e.regenSky();
                        },
                        sub: 2,
                      },
                      axis: {
                        name: "Axis",
                        object: e.mapConfig,
                        key: "skyDomeMovD",
                        type: "select",
                        args: [
                          ["X", "Y"].map((D, E) => ({
                            name: D,
                            value: E,
                          })),
                        ],
                        onChange: function () {
                          e.regenSky();
                        },
                        sub: 2,
                      },
                    },
                  },
                },
              },
              rule: {
                type: "rule",
              },
              ambient: {
                name: "Ambient",
                type: "folder",
                size: "standard",
                children: {
                  sound: {
                    name: "Sound",
                    object: e.mapConfig,
                    key: "ambInd",
                    type: "select",
                    args: [
                      Object.keys(j.soundScapes).map((D) => ({
                        name: D,
                        value: j.soundScapes[D],
                      })),
                    ],
                  },
                  intensity: {
                    name: "Intensity",
                    object: e.mapConfig,
                    key: "ambientI",
                    type: "slider",
                    args: [0.1, 3, 0.1],
                    onChange: function (D, E) {
                      e.ambientLight.intensity = E;
                    },
                  },
                  color: {
                    name: "Color",
                    object: A,
                    key: "ambient",
                    type: "color",
                    onChange: function (D, E) {
                      e.ambientLight.color.set(E);
                    },
                  },
                },
              },
              light: {
                name: "Light",
                type: "folder",
                size: "standard",
                children: {
                  color: {
                    name: "Color",
                    object: A,
                    key: "light",
                    type: "color",
                    onChange: function (D, E) {
                      e.skyLight.color.set(E);
                      e.updateSun();
                    },
                  },
                  distance: {
                    name: "Distance",
                    object: e.mapConfig,
                    key: "lightD",
                    type: "slider",
                    args: [10, 5000, 1],
                    onChange: function () {
                      e.updateSun();
                    },
                  },
                  intensity: {
                    name: "Intensity",
                    object: e.mapConfig,
                    key: "lightI",
                    type: "slider",
                    args: [0.1, 3, 0.1],
                    onChange: function (D, E) {
                      e.ambientLight.intensity = E;
                    },
                  },
                  angle: {
                    name: "Angle",
                    type: "folder",
                    size: "small",
                    children: {
                      x: {
                        name: "X",
                        object: e.mapConfig,
                        key: "sunAngX",
                        type: "slider",
                        args: [0, 360, 1],
                        onChange: function () {
                          e.updateSun();
                        },
                        sub: 1,
                      },
                      y: {
                        name: "Y",
                        object: e.mapConfig,
                        key: "sunAngY",
                        type: "slider",
                        args: [0, 360, 1],
                        onChange: function () {
                          e.updateSun();
                        },
                        sub: 1,
                      },
                    },
                  },
                },
              },
              shadows: {
                name: "Shadows",
                type: "folder",
                size: "standard",
                children: {
                  resolution: {
                    name: "Resolution",
                    object: e.mapConfig,
                    key: "shadowR",
                    type: "slider",
                    args: [128, 4096, 1],
                  },
                  distance: {
                    name: "Distance",
                    object: e.mapConfig,
                    key: "shadowD",
                    type: "slider",
                    args: [128, 4096, 1],
                  },
                },
              },
              weather: {
                name: "Weather",
                type: "folder",
                size: "standard",
                children: {
                  fog: {
                    name: "Fog",
                    type: "folder",
                    size: "small",
                    children: {
                      color: {
                        name: "Color",
                        object: A,
                        key: "fog",
                        type: "color",
                        onChange: function (D, E) {
                          e.scene.fog.color.set(E);
                        },
                        sub: 2,
                      },
                      distance: {
                        name: "Distance",
                        object: e.mapConfig,
                        key: "fogD",
                        type: "slider",
                        args: [10, 15000, 1],
                        onChange: function (D, E) {
                          e.scene.fog.far = E;
                        },
                        sub: 2,
                      },
                    },
                  },
                },
              },
            };
            y.panel.state.setActive(this.objKeys);
            y.panel.right.elem.innerHTML = y._build([
              ...this.objKeys,
              "blueprint",
            ]);
          },
        },
        terrain: {
          show: function () {
            e.resizable.restore(y.panel.right.restore);
            if (
              !y.panel.right.locked ||
              !!y.panel.state.isActive(this.objKeys)
            ) {
              this.blueprint = {
                panelButtons: {
                  type: "panel_buttons",
                  direction: "right",
                  label: "Terrain",
                },
                seed: {
                  name: "Seed",
                  object: e.mapConfig,
                  key: "terrainSeed",
                  type: "text",
                  args: ["Seed"],
                  onChange: function () {
                    e.regenTerrain();
                  },
                },
                random: {
                  name: "Random",
                  object: e.mapConfig,
                  key: "terrainSeed",
                  type: "button",
                  args: ["Generate"],
                  onChange: function () {
                    e.mapConfig.terrainSeed = Math.random()
                      .toString(36)
                      .substring(4);
                    y.panel.state.refresh("panel_right_terrain");
                    e.regenTerrain();
                  },
                  sub: 1,
                },
                seedT: {
                  name: "Tree Seed",
                  object: e.mapConfig,
                  key: "terrainTSeed",
                  type: "text",
                  args: ["Seed"],
                  onChange: function () {
                    e.regenTerrain();
                  },
                },
                randomT: {
                  name: "Random",
                  object: e.mapConfig,
                  key: "terrainTSeed",
                  type: "button",
                  args: ["Generate"],
                  onChange: function () {
                    e.mapConfig.terrainTSeed = Math.random()
                      .toString(36)
                      .substring(4);
                    y.panel.state.refresh("panel_right_terrain");
                    e.regenTerrain();
                  },
                  sub: 1,
                },
                ease: {
                  name: "Easing",
                  object: e.mapConfig,
                  key: "terrainEase",
                  type: "select",
                  args: [
                    e.EASE_LIST.map((z, A) => ({
                      name: z,
                      value: A,
                    })),
                  ],
                  onChange: function () {
                    y.panel.state.refresh("panel_right_terrain");
                    e.regenTerrain();
                  },
                  sub: 1,
                },
                rule: {
                  type: "rule",
                },
                dimensions: {
                  name: "Dimensions",
                  type: "folder",
                  size: "standard",
                  children: {
                    width: {
                      name: "Width",
                      object: e.mapConfig,
                      key: "terrainWidth",
                      type: "slider",
                      args: [j.minTerrainSize, j.maxTerrainSize, 1],
                      onChange: function () {
                        e.regenTerrain();
                      },
                    },
                    length: {
                      name: "Length",
                      object: e.mapConfig,
                      key: "terrainHeight",
                      type: "slider",
                      args: [j.minTerrainSize, j.maxTerrainSize, 1],
                      onChange: function () {
                        e.regenTerrain();
                      },
                    },
                    depth: {
                      name: "Height",
                      object: e.mapConfig,
                      key: "terrainMntMlt",
                      type: "slider",
                      args: [j.minMountainMlt, j.maxMountainMlt, 0.05],
                      onChange: function () {
                        e.regenTerrain();
                      },
                    },
                  },
                },
                style: {
                  name: "Style",
                  type: "folder",
                  size: "standard",
                  children: {
                    color: {
                      name: "Color",
                      type: "folder",
                      size: "small",
                      children: {
                        snow: {
                          name: "Snow",
                          object: e.mapConfig,
                          key: "terrainSnwCol",
                          type: "color",
                          onChange: function () {
                            e.regenTerrain();
                          },
                          sub: 1,
                        },
                        mountain: {
                          name: "Mountain",
                          object: e.mapConfig,
                          key: "terrainMntCol",
                          type: "color",
                          onChange: function () {
                            e.regenTerrain();
                          },
                          sub: 1,
                        },
                        grass: {
                          name: "Grass",
                          object: e.mapConfig,
                          key: "terrainGrsCol",
                          type: "color",
                          onChange: function () {
                            e.regenTerrain();
                          },
                          sub: 1,
                        },
                        dirt: {
                          name: "Dirt",
                          object: e.mapConfig,
                          key: "terrainDrtCol",
                          type: "color",
                          onChange: function () {
                            e.regenTerrain();
                          },
                          sub: 1,
                        },
                        sand: {
                          name: "Sand",
                          object: e.mapConfig,
                          key: "terrainSndCol",
                          type: "color",
                          onChange: function () {
                            e.regenTerrain();
                          },
                          sub: 1,
                        },
                      },
                    },
                  },
                },
              };
              y.panel.state.setActive(this.objKeys);
              y.panel.right.elem.innerHTML = y._build([
                ...this.objKeys,
                "blueprint",
              ]);
            }
          },
        },
        zone: {
          show: function () {
            e.resizable.restore(y.panel.right.restore);
            if (
              !y.panel.right.locked ||
              !!y.panel.state.isActive(this.objKeys)
            ) {
              this.blueprint = {
                panelButtons: {
                  type: "panel_buttons",
                  direction: "right",
                  label: "Zone",
                },
                enabled: {
                  name: "Enabled",
                  object: e.mapConfig,
                  key: "zone",
                  type: "switch",
                  onChange: function () {
                    e.regenZone();
                  },
                },
                speed: {
                  name: "Speed",
                  object: e.mapConfig,
                  key: "zoneSpeed",
                  type: "slider",
                  args: [j.minShrinkSpeed, j.maxShrinkSpeed, 0.1],
                },
                rnd: {
                  name: "Random Endpoint",
                  object: e.mapConfig,
                  key: "zoneRnd",
                  type: "switch",
                  onChange: function () {
                    e.regenZone();
                  },
                },
                rule: {
                  type: "rule",
                },
                dimensions: {
                  name: "Dimensions",
                  type: "folder",
                  size: "standard",
                  children: {
                    size: {
                      name: "Size",
                      object: e.mapConfig,
                      key: "zoneSize",
                      type: "slider",
                      args: [j.minZoneSize, j.maxZoneSize, 10],
                      onChange: function () {
                        e.regenZone();
                      },
                    },
                  },
                },
                style: {
                  name: "Style",
                  type: "folder",
                  size: "standard",
                  children: {
                    color: {
                      name: "Color",
                      type: "folder",
                      size: "small",
                      children: {
                        1: {
                          name: 1,
                          object: e.mapConfig,
                          key: "zoneCol0",
                          type: "color",
                          onChange: function () {
                            e.regenZone();
                          },
                          sub: 1,
                        },
                        2: {
                          name: 2,
                          object: e.mapConfig,
                          key: "zoneCol1",
                          type: "color",
                          onChange: function () {
                            e.regenZone();
                          },
                          sub: 1,
                        },
                        3: {
                          name: 3,
                          object: e.mapConfig,
                          key: "zoneCol2",
                          type: "color",
                          onChange: function () {
                            e.regenZone();
                          },
                          sub: 1,
                        },
                      },
                    },
                  },
                },
              };
              y.panel.state.setActive(this.objKeys);
              y.panel.right.elem.innerHTML = y._build([
                ...this.objKeys,
                "blueprint",
              ]);
            }
          },
        },
        customize: {
          show: function () {
            e.resizable.restore(y.panel.right.restore);
            if (y.panel.right.locked && !y.panel.state.isActive(this.objKeys)) {
              return;
            }
            let z = {};
            let A = ["scaleMap"];
            for (let B of A) {
              Object.defineProperty(z, B, {
                get: () => e.xyzKeys.map((C) => e.advancedOptions[B + C]),
                set: (C) =>
                  e.xyzKeys.forEach((D, E) => {
                    e.advancedOptions[B + D] = C[E];
                  }),
              });
            }
            this.blueprint = {
              panelButtons: {
                type: "panel_buttons",
                direction: "right",
                label: "Customize",
              },
              drunkMap: {
                name: "Drunk Map",
                object: e.advancedOptions,
                key: "drunkMap",
                type: "button",
                args: ["Execute"],
              },
              rule: {
                type: "rule",
              },
              timelapse: {
                name: "Timelapse",
                type: "folder",
                size: "standard",
                children: {
                  timelapseMS: {
                    name: "Timer",
                    object: e.advancedOptions,
                    key: "timelapseMS",
                    type: "slider",
                    args: [100, 5000, 1],
                  },
                  timelapseFollow: {
                    name: "Follow Objects",
                    object: e.advancedOptions,
                    key: "timelapseFollow",
                    type: "switch",
                  },
                  timelapseMap: {
                    line: "wide",
                    object: e.advancedOptions,
                    key: "timelapseMap",
                    type: "button",
                    args: ["Execute"],
                  },
                },
              },
              transform: {
                name: "Transform",
                type: "folder",
                size: "standard",
                children: {
                  position: {
                    name: "Scale",
                    object: z,
                    key: "scaleMap",
                    type: "vector3",
                  },
                  applyScale: {
                    object: e.advancedOptions,
                    key: "scaleMap",
                    line: "wide",
                    type: "button",
                    args: ["Scale"],
                  },
                  reflection: {
                    name: "Reflection",
                    object: e.advancedOptions,
                    key: "reflectDir",
                    type: "select",
                    args: [
                      [
                        {
                          name: "X",
                          value: 0,
                        },
                        {
                          name: "Y",
                          value: 1,
                        },
                        {
                          name: "Z",
                          value: 2,
                        },
                      ],
                    ],
                  },
                  applyReflect: {
                    object: e.advancedOptions,
                    key: "reflectMap",
                    type: "button",
                    line: "wide",
                    args: ["Reflect"],
                  },
                },
              },
              frame: {
                name: "Frame",
                type: "folder",
                size: "standard",
                children: {
                  frameThickness: {
                    name: "Wall Thickness",
                    object: e.advancedOptions,
                    key: "frameThickness",
                    type: "number",
                    args: ["Thickness"],
                  },
                  frameCeiling: {
                    name: "Has Ceiling",
                    object: e.advancedOptions,
                    key: "frameCeiling",
                    type: "switch",
                  },
                  frameFloor: {
                    name: "Has Floor",
                    object: e.advancedOptions,
                    key: "frameFloor",
                    type: "switch",
                  },
                  frameObject: {
                    line: "wide",
                    object: e.advancedOptions,
                    key: "frameObject",
                    type: "button",
                    args: ["Frame It"],
                  },
                },
              },
              breakable: {
                name: "Breakable",
                type: "folder",
                size: "standard",
                children: {
                  breakableHealth: {
                    name: "Health",
                    object: e.advancedOptions,
                    key: "breakableHealth",
                    type: "slider",
                    args: [1, 500, 1],
                  },
                  breakableCollision: {
                    name: "Force Collision",
                    object: e.advancedOptions,
                    key: "breakableCollision",
                    type: "switch",
                  },
                  breakableMap: {
                    line: "wide",
                    object: e.advancedOptions,
                    key: "breakableMap",
                    type: "button",
                    args: ["Execute"],
                  },
                },
              },
              colorize: {
                name: "Colorize",
                type: "folder",
                size: "standard",
                children: {
                  random: {
                    name: "Random",
                    object: e.advancedOptions,
                    key: "colorizeR",
                    type: "button",
                    args: ["Execute"],
                  },
                  gold: {
                    name: "Gold",
                    object: e.advancedOptions,
                    key: "colorizeG",
                    type: "button",
                    args: ["Execute"],
                  },
                  input: {
                    name: "Input",
                    object: e.advancedOptions,
                    key: "colorizeI",
                    type: "button",
                    args: ["Execute"],
                  },
                },
              },
            };
            y.panel.state.setActive(this.objKeys);
            y.panel.right.elem.innerHTML = y._build([
              ...this.objKeys,
              "blueprint",
            ]);
          },
        },
        tools: {
          show: function () {
            e.resizable.restore(y.panel.right.restore);
            if (y.panel.right.locked && !y.panel.state.isActive(this.objKeys)) {
              return;
            }
            let z = {};
            let A = ["Space", "Dir"];
            for (let B of A) {
              Object.defineProperty(z, B, {
                get: () =>
                  e.xyzKeys.map((C) => e.advancedOptions["planner" + C + B]),
                set: (C) =>
                  e.xyzKeys.forEach((D, E) => {
                    e.advancedOptions["planner" + D + B] = C[E];
                  }),
              });
            }
            this.blueprint = {
              panelButtons: {
                type: "panel_buttons",
                direction: "right",
                label: "Tools",
              },
              rule: {
                type: "rule",
              },
              textGenerator: {
                name: "Text Generator",
                type: "folder",
                size: "standard",
                children: {
                  enterText: {
                    name: "Enter Text",
                    object: e.advancedOptions,
                    key: "textGen",
                    type: "button",
                    args: ["Open"],
                  },
                },
              },
              imageConverter: {
                name: "Image Converter",
                type: "folder",
                size: "standard",
                children: {
                  size: {
                    name: "Size",
                    object: e.settings,
                    key: "imageSize",
                    type: "number",
                    onChange: function (C, D) {
                      e.setSettings("imageSize", D);
                    },
                  },
                  depth: {
                    name: "Depth",
                    object: e.settings,
                    key: "imageDepth",
                    type: "number",
                    onChange: function (C, D) {
                      e.setSettings("imageDepth", D);
                    },
                  },
                  collidable: {
                    name: "Collidable",
                    object: e.settings,
                    key: "imageCol",
                    type: "switch",
                    onChange: function (C, D) {
                      e.setSettings("imageCol", D);
                    },
                  },
                  convert: {
                    name: "Convert",
                    object: e.advancedOptions,
                    key: "imageConvert",
                    type: "button",
                    args: ["Convert"],
                  },
                  import: {
                    name: "Import",
                    object: e.advancedOptions,
                    key: "imageImport",
                    type: "button",
                    args: ["Import"],
                  },
                },
              },
              voxelManager: {
                name: "Voxel Manager",
                type: "folder",
                size: "standard",
                children: {
                  merge: {
                    name: "Merge",
                    object: e.settings,
                    key: "mergeVoxels",
                    type: "switch",
                    onChange: function (C, D) {
                      e.setSettings("mergeVoxels", D);
                    },
                  },
                  size: {
                    name: "Size",
                    object: e.settings,
                    key: "voxelSize",
                    type: "number",
                    onChange: function (C, D) {
                      e.setSettings("voxelSize", D);
                    },
                  },
                  convert: {
                    name: "Convert",
                    object: e.advancedOptions,
                    key: "voxelConvert",
                    type: "button",
                    args: ["Convert"],
                  },
                  import: {
                    name: "Import",
                    object: e.advancedOptions,
                    key: "voxelImport",
                    type: "button",
                    args: ["Import"],
                  },
                },
              },
              layoutPlanner: {
                name: "Layout Planner",
                type: "folder",
                size: "standard",
                children: {
                  cube: {
                    name: "Cube",
                    type: "folder",
                    size: "small",
                    children: {
                      size: {
                        name: "Size",
                        object: e.advancedOptions,
                        key: "plannerSize",
                        type: "number",
                        sub: 1,
                      },
                      color: {
                        name: "Color",
                        object: e.advancedOptions,
                        key: "plannerColor",
                        type: "color",
                        sub: 1,
                      },
                    },
                  },
                  numberOfCubes: {
                    name: "Cubes in XYZ",
                    object: z,
                    key: "Dir",
                    type: "vector3",
                  },
                  ammountOfSpace: {
                    name: "Space in XYZ",
                    object: z,
                    key: "Space",
                    type: "vector3",
                  },
                  applyPlanner: {
                    line: "wide",
                    object: e.advancedOptions,
                    key: "plannerExecute",
                    type: "button",
                    args: ["Execute"],
                  },
                },
              },
            };
            y.panel.state.setActive(this.objKeys);
            y.panel.right.elem.innerHTML = y._build([
              ...this.objKeys,
              "blueprint",
            ]);
          },
        },
        grouping: {
          show: function () {
            e.resizable.restore(y.panel.right.restore);
            y.panel.right.grouping.objKeys;
            if (y.panel.right.locked && !y.panel.state.isActive(this.objKeys)) {
              return;
            }
            let z = [];
            let A = Object.getOwnPropertyDescriptors(ObjectInstance.prototype);
            for (let B in A) {
              if (A[B].set) {
                z.push(B);
              }
            }
            this.blueprint = {
              panelButtons: {
                type: "panel_buttons",
                direction: "right",
                label: "Grouping",
              },
              rule: {
                type: "rule",
              },
              transform: {
                name: "Transform",
                type: "folder",
                size: "standard",
                children: {
                  reflect: {
                    name: "Reflect",
                    type: "folder",
                    size: "small",
                    children: {
                      direction: {
                        name: "Direction",
                        object: e.advancedOptions,
                        key: "groupReflectDir",
                        type: "select",
                        args: [
                          [
                            {
                              name: "X",
                              value: 0,
                            },
                            {
                              name: "Y",
                              value: 1,
                            },
                            {
                              name: "Z",
                              value: 2,
                            },
                          ],
                        ],
                        sub: 1,
                      },
                      execute: {
                        line: "wide",
                        object: e.advancedOptions,
                        key: "groupReflect",
                        type: "button",
                        args: ["Execute"],
                        sub: 1,
                      },
                    },
                  },
                },
              },
              style: {
                name: "Style",
                type: "folder",
                size: "standard",
                children: {
                  texture: {
                    name: "Texture",
                    object: e.advancedOptions,
                    key: "texture",
                    type: "select",
                    args: [
                      Object.keys(e.textureList).map((C) => ({
                        name: C,
                        value: e.textureList[C],
                      })),
                    ],
                    onChange: function (C, D) {
                      e.editGroup("texture", D);
                    },
                  },
                  color: {
                    name: "Color",
                    object: e.advancedOptions,
                    key: "editColor",
                    type: "button",
                    args: ["Open"],
                  },
                },
              },
              custom: {
                name: "Custom",
                type: "folder",
                size: "standard",
                children: {
                  key: {
                    name: "Key",
                    object: e.advancedOptions,
                    key: "editCustomKey",
                    type: "select",
                    args: [
                      z.map((C) => ({
                        name: C,
                        value: C,
                      })),
                    ],
                    onChange: function () {},
                  },
                  execute: {
                    line: "wide",
                    object: e.advancedOptions,
                    key: "editCustomExec",
                    type: "button",
                    args: ["Execute"],
                  },
                },
              },
              prefab: {
                name: "Prefab",
                type: "folder",
                size: "standard",
                children: {
                  autoGroup: {
                    name: "Auto Group",
                    object: e.settings,
                    key: "assetAutoGroup",
                    type: "switch",
                    onChange: function (C, D) {
                      this.setSettings("assetAutoGroup", D);
                    },
                  },
                  rotation: {
                    name: "Rotation",
                    object: e.advancedOptions,
                    key: "rotation",
                    type: "slider",
                    args: [0, 359, 1],
                  },
                  import: {
                    name: "Import",
                    type: "folder",
                    size: "small",
                    children: {
                      json: {
                        name: "Json",
                        object: e.advancedOptions,
                        key: "json",
                        type: "button",
                        args: ["Import"],
                        sub: 1,
                      },
                      file: {
                        name: "File",
                        object: e.advancedOptions,
                        key: "file",
                        type: "button",
                        args: ["Import"],
                        sub: 1,
                      },
                    },
                  },
                  objectPainter: {
                    name: "Object Painter",
                    object: e.advancedOptions,
                    key: "objectPainter",
                    type: "switch",
                    onChange: function (C, D) {
                      objPaint.style.display = D ? null : "none";
                    },
                  },
                  objPaint: {
                    type: "div",
                    id: "objPaint",
                    show: e.advancedOptions.objectPainter,
                    children: {
                      json: {
                        name: "JSON",
                        object: e.advancedOptions,
                        key: "objectPainterJson",
                        type: "text",
                        args: ["JSON"],
                        sub: 1,
                      },
                    },
                  },
                },
              },
            };
            y.panel.state.setActive(this.objKeys);
            y.panel.right.elem.innerHTML = y._build([
              ...this.objKeys,
              "blueprint",
            ]);
          },
        },
      },
    },
    _window: {
      controls: {
        default: {
          gen: function () {
            this.blueprint = {
              rule: {
                type: "rule",
              },
            };
            this.blueprint.movement = {
              name: "Movement",
              type: "folder",
              size: "standard",
              children: {
                fowardKey: {
                  name: "Fly forward",
                  object: e.settings,
                  key: "fowardKey",
                  type: "key",
                  args: [[y._html.arrow("up")], true],
                  onChange: function (z, A) {
                    A = A.toUpperCase();
                    e.setSettings(e.property, A);
                  },
                },
                backwardKey: {
                  name: "Fly backwards",
                  object: e.settings,
                  key: "backwardKey",
                  type: "key",
                  args: [[y._html.arrow("down")], true],
                  onChange: function (z, A) {
                    A = A.toUpperCase();
                    e.setSettings(e.property, A);
                  },
                },
                leftKey: {
                  name: "Fly left",
                  object: e.settings,
                  key: "leftKey",
                  type: "key",
                  args: [[y._html.arrow("left")], true],
                  onChange: function (z, A) {
                    A = A.toUpperCase();
                    e.setSettings(e.property, A);
                  },
                },
                rightKey: {
                  name: "Fly right",
                  object: e.settings,
                  key: "rightKey",
                  type: "key",
                  args: [[y._html.arrow("right")], true],
                  onChange: function (z, A) {
                    A = A.toUpperCase();
                    e.setSettings(e.property, A);
                  },
                },
                upKey: {
                  name: "Fly up",
                  object: e.settings,
                  key: "upKey",
                  type: "key",
                  args: [[], true],
                  onChange: function (z, A) {
                    A = A.toUpperCase();
                    e.setSettings(e.property, A);
                  },
                },
                downKey: {
                  name: "Fly down",
                  object: e.settings,
                  key: "downKey",
                  type: "key",
                  args: [[], true],
                  onChange: function (z, A) {
                    A = A.toUpperCase();
                    e.setSettings(e.property, A);
                  },
                },
                shiftKey: {
                  name: "Hold to fly faster",
                  object: {
                    val: "Shift",
                  },
                  key: "val",
                  type: "key",
                },
                speed: {
                  name: "Speed",
                  type: "folder",
                  size: "small",
                  children: {
                    speedNormal: {
                      name: "Normal",
                      object: e.settings,
                      key: "speedNormal",
                      type: "number",
                      onChange: function (z, A) {
                        e.setSettings(
                          "speedNormal",
                          Math.abs(A) || e.defaultSettings.speedNormal,
                        );
                      },
                      sub: 1,
                    },
                    speedSprint: {
                      name: "Sprinting",
                      object: e.settings,
                      key: "speedSprint",
                      type: "number",
                      onChange: function (z, A) {
                        e.setSettings(
                          "speedSprint",
                          Math.abs(A) || e.defaultSettings.speedSprint,
                        );
                      },
                      sub: 1,
                    },
                    speedReset: {
                      name: "Reset Speed",
                      object: e.advancedOptions,
                      key: "speedReset",
                      type: "button",
                      args: ["Reset"],
                      sub: 1,
                    },
                  },
                },
              },
            };
            this.blueprint.transform = {
              name: "Transform",
              type: "folder",
              size: "standard",
              children: {
                ...[
                  {
                    keys: ["1"],
                    name: "Translate",
                  },
                  {
                    keys: ["2"],
                    name: "Rotate",
                  },
                  {
                    keys: ["3"],
                    name: "Scale",
                  },
                  {
                    keys: ["`"],
                    name: "Toggle World / Local space",
                  },
                ].map((z) => ({
                  name: z.name,
                  object: {
                    val: z.keys.join(" or "),
                  },
                  key: "val",
                  type: "key",
                })),
              },
            };
            this.blueprint.edit = {
              name: "Edit",
              type: "folder",
              size: "standard",
              children: {
                ...[
                  {
                    keys: ["Ctrl + Z"],
                    name: "Undo",
                  },
                  {
                    keys: ["Ctrl + Y", "Shift + Ctrl + Z"],
                    name: "Redo",
                  },
                ].map((z) => ({
                  name: z.name,
                  object: {
                    val: z.keys.join(" or "),
                  },
                  key: "val",
                  type: "key",
                })),
              },
            };
            this.blueprint.object = {
              name: "Object",
              type: "folder",
              size: "standard",
              children: {
                faceModeKey: {
                  name: "Face Selection Mode",
                  object: e.settings,
                  key: "faceModeKey",
                  type: "key",
                  args: [[], true],
                  onChange: function (z, A) {
                    A = A.toUpperCase();
                    e.setSettings(e.property, A);
                    e.updateFaceSelection();
                  },
                },
                groupModeKey: {
                  name: "Group Selection Mode",
                  object: e.settings,
                  key: "groupModeKey",
                  type: "key",
                  args: [[], true],
                  onChange: function (z, A) {
                    A = A.toUpperCase();
                    e.setSettings(e.property, A);
                    e.updateGroupSelection();
                  },
                },
                delElement: {
                  name: "Delete element",
                  object: {
                    val: "Del or Backspace",
                  },
                  key: "val",
                  type: "key",
                },
                snapping: {
                  name: "Toggle snapping",
                  object: {
                    val: "Control",
                  },
                  key: "val",
                  type: "key",
                },
                collidable: {
                  name: "Toggle collidable",
                  object: {
                    val: "Shift + C",
                  },
                  key: "val",
                  type: "key",
                },
                visible: {
                  name: "Toggle visibilty",
                  object: {
                    val: "Shift + V",
                  },
                  key: "val",
                  type: "key",
                },
              },
            };
            return y._build([...this.objKeys, "blueprint"]);
          },
        },
        advanced: {
          gen: function () {
            this.blueprint = {
              placeholder: {
                name: "Create placeholder",
                object: {
                  val: "P",
                },
                key: "val",
                type: "key",
              },
              hitbox: {
                name: "Hitbox fixer",
                object: {
                  val: "Shift + F",
                },
                key: "val",
                type: "key",
              },
              flipXZ: {
                name: "Flip x/z size",
                object: {
                  val: "F",
                },
                key: "val",
                type: "key",
              },
              quickAdd: {
                name: "Quick Add",
                object: {
                  val: "X",
                },
                key: "val",
                type: "key",
              },
              rule: {
                type: "rule",
              },
            };
            this.blueprint.group = {
              name: "Group",
              type: "folder",
              size: "standard",
              children: {
                ...[
                  {
                    keys: ["Shift + Alt + G"],
                    name: "Remove all groups",
                  },
                  {
                    keys: ["Shift + G"],
                    name: "Create group / Remove group if exist",
                  },
                  {
                    keys: ["Shift + R"],
                    name: "Duplicate Group / Object",
                  },
                  {
                    keys: ["Ctrl + C"],
                    name: "Copy group",
                  },
                  {
                    keys: ["Ctrl + V"],
                    name: "Paste group",
                  },
                ].map((z) => ({
                  name: z.name,
                  object: {
                    val: z.keys.join(" or "),
                  },
                  key: "val",
                  type: "key",
                })),
              },
            };
            this.blueprint.file = {
              name: "File",
              type: "folder",
              size: "standard",
              children: {
                ...[
                  {
                    keys: ["Shift + Click + Import"],
                    name: "Import from file",
                  },
                  {
                    keys: ["Shift + Click + Export"],
                    name: "Export & copy",
                  },
                ].map((z) => ({
                  name: z.name,
                  object: {
                    val: z.keys.join(" or "),
                  },
                  key: "val",
                  type: "key",
                })),
              },
            };
            this.blueprint.file = {
              name: "File",
              type: "folder",
              size: "standard",
              children: {
                ...[
                  {
                    keys: ["Shift + Click (w/ Objectpainter)"],
                    name: "Paste preset JSON",
                  },
                ].map((z) => ({
                  name: z.name,
                  object: {
                    val: z.keys.join(" or "),
                  },
                  key: "val",
                  type: "key",
                })),
              },
            };
            return y._build([...this.objKeys, "blueprint"]);
          },
        },
      },
      settings: {
        general: {
          gen: function () {
            this.blueprint = {
              controls: {
                name: "Controls",
                object: {},
                key: "",
                type: "button",
                args: ["Open Controls"],
                onChange: function () {
                  showWindow(1);
                },
              },
              autoBackup: {
                name: "Auto Backup",
                object: e.settings,
                key: "autoBackup",
                type: "slider",
                args: [0, 25, 1],
                onChange: function (z, A) {
                  e.setSettings("autoBackup", Math.abs(A));
                  e.initAutoBackup();
                },
              },
              uiScale: {
                name: "UI Scale",
                object: e.settings,
                key: "uiScale",
                type: "slider",
                args: [0.5, 1.5, 0.1],
                onChange: function (z, A) {
                  e.setSettings("uiScale", A);
                  e.scaleUI();
                },
              },
              pointerLock: {
                name: "Pointer Lock",
                object: e.settings,
                key: "pointerLock",
                type: "switch",
                onChange: function (z, A) {
                  e.setSettings("pointerLock", A);
                },
              },
              disableWarnings: {
                name: "Disable Warnings",
                object: e.settings,
                key: "disableWarnings",
                type: "switch",
                onChange: function (z, A) {
                  e.setSettings("disableWarnings", A);
                  e.clearWarnings();
                },
              },
              rule: {
                type: "rule",
              },
              render: {
                name: "Render",
                type: "folder",
                size: "standard",
                closed: true,
                children: {
                  res: {
                    name: "Resolution",
                    object: e.settings,
                    key: "resMltV",
                    type: "slider",
                    args: [0.1, 2, 0.1],
                    onChange: function (z, A) {
                      e.setSettings("resMltV", Math.abs(A));
                      e.setResMlt();
                    },
                  },
                  antiAlias: {
                    name: "Anti-aliasing",
                    object: e.settings,
                    key: "resMltV",
                    type: "switch",
                    onChange: function (z, A) {
                      e.setSettings("antiAlias", A);
                      alert("This change will occur after you refresh");
                    },
                  },
                },
              },
              history: {
                name: "History",
                type: "folder",
                size: "standard",
                closed: true,
                children: {
                  disable: {
                    name: "Disable",
                    object: e.settings,
                    key: "disableHistory",
                    type: "switch",
                    onChange: function (z, A) {
                      grid.style.display = A ? "none" : null;
                      e.setSettings("disableHistory", A);
                      e.toggleHistory(A);
                    },
                  },
                  history: {
                    type: "div",
                    id: "grid",
                    show: !e.settings.disableHistory,
                    children: {
                      limit: {
                        name: "Limit",
                        object: e.settings,
                        key: "historyLimit",
                        type: "slider",
                        args: [0, 1000, 1],
                        onChange: function (z, A) {
                          e.setSettings("historyLimit", A);
                        },
                        sub: 1,
                      },
                    },
                  },
                },
              },
              game: {
                name: "Game",
                type: "folder",
                size: "standard",
                closed: true,
                children: {
                  showRealHitbox: {
                    name: "Show Real Hitbox",
                    object: e.settings,
                    key: "showRealHitbox",
                    type: "switch",
                    onChange: function (z, A) {
                      e.setSettings("showRealHitbox", A);
                      ObjectInstance.showRealHitbox = A;
                    },
                  },
                },
              },
            };
            return y._build([...this.objKeys, "blueprint"]);
          },
        },
        display: {
          gen: function () {
            this.blueprint = {
              darkMode: {
                name: "Dark Mode",
                object: e.settings,
                key: "darkMode",
                type: "switch",
                onChange: function (z, A) {
                  e.setSettings("darkMode", A);
                  e.updateTheme();
                },
              },
              rule: {
                type: "rule",
              },
              grid: {
                name: "Grid",
                type: "folder",
                size: "standard",
                children: {
                  gridVisibility: {
                    name: "Visible",
                    object: e.settings,
                    key: "gridVisibility",
                    type: "switch",
                    onChange: function (z, A) {
                      grid.style.display = A ? null : "none";
                      e.setSettings("gridVisibility", A);
                      e.updateGridHelper();
                    },
                  },
                  grid: {
                    type: "div",
                    id: "grid",
                    show: e.settings.gridVisibility,
                    children: {
                      gridOpacity: {
                        name: "Opacity",
                        object: e.settings,
                        key: "gridOpacity",
                        type: "slider",
                        args: [0.05, 1, 0.05],
                        onChange: function (z, A) {
                          e.setSettings("gridOpacity", A);
                          e.updateGridHelper();
                        },
                        sub: 1,
                      },
                      gridSize: {
                        name: "Size",
                        object: e.settings,
                        key: "gridSize",
                        type: "number",
                        onChange: function (z, A) {
                          e.setSettings("gridSize", Math.abs(A));
                          e.updateGridHelper();
                        },
                        sub: 1,
                      },
                      gridSpacing: {
                        name: "Spacing",
                        object: e.settings,
                        key: "gridSpacing",
                        type: "number",
                        onChange: function (z, A) {
                          e.setSettings(
                            "gridSpacing",
                            Math.abs(A) || e.defaultSettings.gridSpacing,
                          );
                          e.updateGridHelper();
                        },
                        sub: 1,
                      },
                    },
                  },
                  gridReset: {
                    name: "Reset Grid",
                    object: e.advancedOptions,
                    key: "gridReset",
                    type: "button",
                    args: ["Reset"],
                  },
                },
              },
              deathBarrier: {
                name: "Death Barrier",
                type: "folder",
                size: "standard",
                children: {
                  dbVisibility: {
                    name: "Visible",
                    object: e.settings,
                    key: "dbVisibility",
                    type: "switch",
                    onChange: function (z, A) {
                      deathBarrier.style.display = A ? null : "none";
                      e.setSettings("dbVisibility", A);
                      e.updateDeathBarrier();
                    },
                  },
                  deathBarrier: {
                    type: "div",
                    id: "deathBarrier",
                    show: e.settings.dbVisibility,
                    children: {
                      dbOpacity: {
                        name: "Opacity",
                        object: e.settings,
                        key: "dbOpacity",
                        type: "slider",
                        args: [0.05, 1, 0.05],
                        onChange: function (z, A) {
                          e.setSettings("dbOpacity", A);
                          e.updateDeathBarrier();
                        },
                        sub: 1,
                      },
                    },
                  },
                  dbReset: {
                    name: "Reset Barrier",
                    object: e.advancedOptions,
                    key: "dbReset",
                    type: "button",
                    args: ["Reset"],
                  },
                },
              },
            };
            return y._build([...this.objKeys, "blueprint"]);
          },
        },
        object: {
          gen: function () {
            this.blueprint = {
              triggerCons: {
                name: "Trigger Connections",
                object: e.settings,
                key: "triggerCons",
                type: "switch",
                onChange: function (z, A) {
                  e.setSettings("triggerCons", A);
                  e.checkConnections();
                },
              },
              selectThrough: {
                name: "Select through invisible objects [ALT]",
                object: e.settings,
                key: "selectThroughInvis",
                type: "switch",
                onChange: function (z, A) {
                  e.setSettings("selectThroughInvis", A);
                },
              },
              borderVisuals: {
                name: "Object Border Visuals",
                object: e.settings,
                key: "borderVisuals",
                type: "switch",
                onChange: function (z, A) {
                  e.setSettings("borderVisuals", A);
                  e.updateBorderVisuals();
                },
              },
              res: {
                name: "Highlight",
                object: e.settings,
                key: "objectHighlight",
                type: "switch",
                onChange: function (z, A) {
                  e.setSettings("objectHighlight", A);
                },
              },
              antiAlias: {
                name: "Create Near",
                object: e.settings,
                key: "createObjectNear",
                type: "switch",
                onChange: function (z, A) {
                  e.setSettings("createObjectNear", A);
                },
              },
              togLightCones: {
                name: "Lightcone Boundingbox",
                object: e.advancedOptions,
                key: "togLightCones",
                type: "button",
                args: ["Toggle"],
              },
              rule: {
                type: "rule",
              },
              config: {
                name: "Config",
                type: "folder",
                size: "standard",
                children: {
                  degToRad: {
                    name: "Anti Radians",
                    object: e.settings,
                    key: "degToRad",
                    type: "switch",
                    onChange: function (z, A) {
                      e.setSettings("degToRad", A);
                    },
                  },
                  preserveFolderState: {
                    name: "Preserve Folders",
                    object: e.settings,
                    key: "preserveFolderState",
                    type: "switch",
                    onChange: function (z, A) {
                      e.setSettings("preserveFolderState", A);
                    },
                  },
                },
              },
              snapping: {
                name: "Snapping",
                type: "folder",
                size: "standard",
                children: {
                  translation: {
                    name: "Translation",
                    object: e.settings,
                    key: "translationSnapping",
                    type: "slider",
                    args: [0.001, 25, 0.001],
                    onChange: function (z, A) {
                      e.setSettings(
                        "translationSnapping",
                        Math.abs(A) || e.defaultSettings.translationSnapping,
                      );
                      e.updateSnapping();
                    },
                  },
                  rotation: {
                    name: "Rotation",
                    object: e.settings,
                    key: "rotationSnapping",
                    type: "slider",
                    args: [0.001, 45, 0.001],
                    onChange: function (z, A) {
                      e.setSettings(
                        "rotationSnapping",
                        Math.abs(A) || e.defaultSettings.rotationSnapping,
                      );
                      e.updateSnapping();
                    },
                  },
                  scale: {
                    name: "Scale",
                    object: e.settings,
                    key: "scaleSnapping",
                    type: "slider",
                    args: [0.001, 25, 0.001],
                    onChange: function (z, A) {
                      e.setSettings(
                        "scaleSnapping",
                        Math.abs(A) || e.defaultSettings.scaleSnapping,
                      );
                      e.updateSnapping();
                    },
                  },
                  reset: {
                    name: "Reset Snapping",
                    object: e.advancedOptions,
                    key: "snappingReset",
                    type: "button",
                    args: ["Reset"],
                  },
                },
              },
            };
            return y._build([...this.objKeys, "blueprint"]);
          },
        },
        quickgui: {
          gen: function () {
            this.blueprint = {
              enabled: {
                name: "Enabled",
                object: e.settings,
                key: "quickGUI",
                type: "switch",
                onChange: function (z, A) {
                  quickgui.style.display = A ? null : "none";
                  e.setSettings("quickGUI", A);
                },
              },
              quickgui: {
                type: "div",
                id: "quickgui",
                show: e.settings.quickGUI,
                children: {
                  quickGUIOpen: {
                    name: "Open On",
                    object: e.settings,
                    key: "quickGUIOpen",
                    type: "select",
                    args: [
                      [
                        {
                          name: "Middle Click",
                          value: 0,
                        },
                        {
                          name: "Right Click",
                          value: 1,
                        },
                      ],
                    ],
                    onChange: function (z, A) {
                      e.setSettings("quickGUIOpen", parseInt(A));
                    },
                    sub: 1,
                  },
                },
              },
            };
            return y._build([...this.objKeys, "blueprint"]);
          },
        },
      },
      quickaddcust: {
        gen: function () {
          let z = [];
          let A = [];
          let B = [];
          for (let C in k.prefabs) {
            if (
              (!k.prefabs[C].localOnly || !j.isProd) &&
              !k.prefabs[C].custom &&
              !k.prefabs[C].noExport &&
              k.prefabs[C].name != ""
            ) {
              (k.prefabs[C].tool || k.prefabs[C].tool2
                ? A
                : k.prefabs[C].gen
                  ? z
                  : B
              ).push({
                name: h.formatConstName(k.prefabs[C].name),
                object: {},
                key: "",
                type: "button",
                args: ["Add"],
                onChange: function () {
                  windows[3].changeButton({
                    name: h.formatConstName(k.prefabs[C].name),
                    desc: "Click to add",
                    item: C,
                  });
                },
              });
            }
          }
          this.blueprint = {
            rule: {
              type: "rule",
            },
            general: {
              name: "General",
              type: "folder",
              size: "standard",
              children: {
                customAsset: {
                  name: "Custom Asset",
                  object: {},
                  key: "",
                  type: "button",
                  args: ["Add"],
                  onChange: function () {
                    windows[3].changeButton({
                      name: "Custom Asset",
                      desc: "Import community made assets",
                      cust: true,
                    });
                  },
                },
                placeholder: {
                  name: "Placeholder",
                  object: {},
                  key: "",
                  type: "button",
                  args: ["Add"],
                  onChange: function () {
                    windows[3].changeButton({
                      name: "Placeholder",
                      desc: "Stretch over objects to form a group",
                      place: true,
                    });
                  },
                },
              },
            },
            basic: {
              name: "Basic",
              type: "folder",
              size: "standard",
              children: {
                ...B,
              },
            },
            models: {
              name: "Models",
              type: "folder",
              size: "standard",
              children: {
                ...z,
              },
            },
            tools: {
              name: "Tools",
              type: "folder",
              size: "standard",
              children: {
                ...A,
              },
            },
          };
          return y._build([...this.objKeys, "blueprint"]);
        },
      },
    },
    _quicksettings: {
      gen: function () {
        this.blueprint = {
          duplicate: {
            name: "Duplicate",
            type: "toolbar",
            pos: "option",
            onClick: function () {
              if (e.quickGUI.obj.objType == "PLACEHOLDER") {
                e.duplicateGroup(e.quickGUI.obj);
              } else {
                e.duplicateObject(e.quickGUI.obj);
              }
            },
          },
          delete: {
            name: "Delete",
            type: "toolbar",
            pos: "option",
            onClick: function () {
              if (e.quickGUI.obj.objType == "PLACEHOLDER") {
                e.removeGroup(e.quickGUI.obj);
              } else {
                e.removeObject({
                  boundingMesh: e.quickGUI.obj,
                });
              }
            },
          },
          rule0: {
            type: "rule",
          },
          group: {
            name: "Group",
            type: "toolbar",
            pos: "menu",
            children: {
              form: {
                name: "Create",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.copyObjects(false, true, false, e.quickGUI.obj);
                },
              },
              separate: {
                name: "Stop",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.stopGroup(false, e.quickGUI.obj);
                },
              },
              rule: {
                type: "rule",
              },
              copy: {
                name: "Copy",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.copyObjects(false, false, false, e.quickGUI.obj);
                },
              },
              paste: {
                name: "Paste",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.pasteObjects(e.quickGUI.obj);
                },
              },
            },
          },
          rule1: {
            type: "rule",
          },
          fixHitbox: {
            name: "Fix Hitbox",
            type: "toolbar",
            pos: "option",
            onClick: function () {
              e.fixHitbox(this.quickGUI.obj);
            },
          },
          rule2: {
            type: "rule",
          },
          replace: {
            name: "Replace",
            type: "toolbar",
            pos: "menu",
            children: {
              form: {
                name: "JSON",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.jsonInput(false, e.quickGUI.obj);
                },
              },
              separate: {
                name: "File",
                type: "toolbar",
                pos: "option",
                onClick: function () {
                  e.jsonInput(true, e.quickGUI.obj);
                },
              },
            },
          },
          rule3: {
            type: "rule",
          },
          json: {
            name: "JSON",
            type: "toolbar",
            pos: "menu",
            children: {
              textArea: {
                type: "toolbar",
                pos: "textarea",
              },
            },
          },
        };
        return y._build([...this.objKeys, "blueprint"]);
      },
    },
  };
  h.getObjKeys(y, [
    "_html",
    "update",
    "action",
    "_build",
    "state",
    "blueprint",
    "folderStore",
    "show",
    "gen",
    "elem",
    "restore",
  ]).forEach((z) => {
    let A = y;
    let B = z.split("|");
    B.forEach((C) => (A = A[C]));
    A.objKeys = B;
  });
  window.addEventListener("mousemove", y.update.number.mousemove);
  window.addEventListener("mouseup", y.update.number.mouseup);
  window.addEventListener("keydown", y.update.key.keydown);
  window.addEventListener("mousedown", y.update.key.mousedown);
  y.update.color.init();
  window.GUI = h.removePrivateKeys(y);
  return y;
};
